import * as clipboard from "clipboard-polyfill";
import linkifyHtml from "linkify-html";
import sanitizeHtml from 'sanitize-html';
export default {
    data: function () {
        return {
            chosenInstructions: null,
            hasEditableRequiredEmail: false,
            triedToSubmit: false,
            email_clients: [
                {
                    shortname: 'gmail',
                    name: 'Gmail',
                    logo: '/website/email-browser-logos/gmail.png',
                },
                {
                    shortname: 'ios',
                    name: 'iPhone / iPad',
                    logo: '/website/email-browser-logos/ios.png',
                },
                {
                    shortname: 'outlook',
                    name: 'Outlook',
                    logo: '/website/email-browser-logos/outlook.png',
                },
                {
                    shortname: 'apple',
                    name: 'Apple Mail',
                    logo: '/website/email-browser-logos/apple-mail.png',
                },
                {
                    shortname: 'yahoo',
                    name: 'Yahoo Mail',
                    logo: '/website/email-browser-logos/yahoo.png',
                },
                {
                    shortname: 'outlookcom',
                    name: 'Outlook.com',
                    logo: '/website/email-browser-logos/outlook.png',
                },
                {
                    shortname: 'android',
                    name: 'Google Android',
                    logo: '/website/email-browser-logos/android.png',
                },
                {
                    shortname: 'samsung',
                    name: 'Samsung Mail',
                    logo: '/website/email-browser-logos/samsung-mail.png',
                },
                {
                    shortname: 'thunderbird',
                    name: 'Thunderbird',
                    logo: '/website/email-browser-logos/thunderbird.png',
                },
                {
                    shortname: 'windowsmail',
                    name: 'Windows Mail',
                    logo: '/website/email-browser-logos/windowsmail.png',
                },
                {
                    shortname: 'other',
                    name: 'Other',
                    logo: '/website/email-browser-logos/other.png',
                },
                {
                    shortname: 'html',
                    name: 'HTML Code',
                    logo: '/website/email-browser-logos/html.png',
                }
            ],
            instructions: {
                gmail: '<h5>Gmail</h5><ol><li>Copy the signature from this website or your inbox, then in Gmail click the Gear icon in the top right of the screen and then choose Settings.</li><li>Click the "See all settings" button</li><li>In the General tab scroll down to the "Signature" section.</li><li>Click "Create New" and name your signature.</li><li>Paste your signature in the box using Ctrl+V on Windows or Command+V on Mac.</li><li>At the bottom of the page, click Save Changes.</li></ol><p><a href="' + this.articleLink() + 'how-to-add-signature-in-gmail" target="_blank">View</a> the detailed step by step tutorial with screenshots.</p>',
                ios: '<h5>iPhone/iPad</h5><ol><li><strong>It is NOT recommended to use the "Copy Signature to Clipboard" button on an iPhone/iPad.</strong></li><li>Send your signature to your inbox on your mobile device. With an account use the <strong>Send Via Email</strong> button, otherwise use your desktop computer to send your mobile device the signature.</li><li>Copy the signature from that email by pressing and holding, then choosing Copy.</li><li>Launch Settings, Tap Mail, Tap Signature</li><li>Delete any signature that is already there.</li><li>Tap and hold the empty Signature field to bring up the selection tool.</li><li>Tap Paste from the pop-up menu to insert your rich HTML signature. When you paste in the copied signature iOS will automatically remove all formatting.</li><li><strong>Shake your iPhone or iPad</strong> to activate the Undo tool.</li><li>Tap Undo to remove any automatic formatting and bring back color or content from the original paste.</li></ol><p><a href="' + this.articleLink() + 'how-to-add-signature-on-iphone" target="_blank">View</a> the detailed step by step tutorial with screenshots.</p>',
                outlook: '<h5>Outlook (New)</h5><ol><li>Copy the signature from this website or your inbox, then within "New" Outlook select the Settings Gear icon near the top right of the window.</li><li>In the left hand sidebar find the "Account" tab near the top and then click on "Signatures" in the middle column.</li><li>Click "New Signature" and give it a name.</li><li>In the large white box paste your signature using Ctrl+V on Windows or Command+V on Mac.</li><li>Select Save when you are done.</li><li>If you want your signature to appear at the bottom of emails automatically, select which signature you would want for New Messages, and for Replies/Forwards. Then save again.</li></ol><h5>Outlook (Old)</h5><ol><li>Copy the signature from this website or your inbox, then in Outlook and click "New Email".</li><li>Click "Insert", and then "Signature", then "Signatures" from the menu.</li><li>Click "New", and name your signature.</li><li>Paste the signature into the Edit signature box using Ctrl+V on Windows or Command+V on Mac.</li><li>Choose OK to save your new signature and return to your message.</li></ol><p><a href="' + this.articleLink() + 'how-to-add-signature-in-outlook" target="_blank">View</a> the detailed step by step tutorial with screenshots.</p>',
                apple: '<h5>Apple Mail</h5><ol><li>Copy the signature from this website or your inbox, then in the Mail app on your Mac, choose Mail > Preferences.</li><li>Click the "Signatures" tab.</li><li>In the left column, select the email account where you want to use the signature.</li><li>Click the "Plus" button below the middle column.</li><li>In the middle column, type a name for the signature.</li><li>Uncheck the box "Always match my default message font"</li><li>In the right column (the preview), paste your signature using Command+V.</li><li>Images appear as if they are broken. This is ok! This is a bug in Apple Mail. When you start composing a new email the images will work!</li></ol><p><a href="' + this.articleLink() + 'how-to-add-signature-in-apple-mail" target="_blank">View</a> the detailed step by step tutorial with screenshots.</p>',
                yahoo: '<h5>Yahoo Mail</h5><ol><li>Copy the signature from this website or your inbox, then in Yahoo Mail, on the top-right, click the Settings icon.</li><li>Click the More Settings link.</li><li>Click "Writing email".</li><li>Under Signature toggle the switch next your email address to the right. The switch will turn blue.</li><li>Paste your signature in the Signature field that appears below the switch using Ctrl+V on Windows or Command+V on Mac.</li><li>Your signature is saved automatically.</li></ol><p><a href="' + this.articleLink() + 'how-to-add-signature-in-yahoo-mail" target="_blank">View</a> the detailed step by step tutorial with screenshots.</p>',
                android: '<h5>Android Mail</h5><ol><li>Copy the signature from this website or your inbox, then in your Email App, click Menu.</li><li>Click More.</li><li>Tap Settings.</li><li>Choose "General Settings".</li><li>Check "Use Signature" to On.</li><li>Tap Signature and paste the signature for that particular account.</li></ol>',
                outlookcom: '<h5>Outlook.com</h5><ol><li>Copy the signature from this website or your inbox, then on the Outlook website select the Settings Gear icon near the top right of the page.</li><li>In the left hand sidebar find the "Account" tab near the top and then click on "Signatures" in the middle column.</li><li>Click "New Signature" and give it a name.</li><li>In the large white box paste your signature using Ctrl+V on Windows or Command+V on Mac.</li><li>Select Save when you are done.</li><li>If you want your signature to appear at the bottom of emails automatically, select which signature you would want for New Messages, and for Replies/Forwards, then save again.</li></ol><p><a href="' + this.articleLink() + 'how-to-add-signature-in-outlook-online" target="_blank">View</a> the detailed step by step tutorial with screenshots.</p>',
                samsung: '<h5>Samsung Mail</h5><ol><li>Copy the signature from this website or your inbox, then in the Samsung Mail app, tap the top left menu icon with three bars.</li><li>Tap on settings gear icon in top right.</li><li>Tap on the account where you want to apply the signature.</li><li>Under account settings, turn on signature and tap to edit it.</li><li>In order to paste the signature, at the top right of the keyboard, tap the three dots and choose clipboard and then look for the signature to paste.</li></ol>',
                thunderbird: '<h5>Thunderbird</h5><ol><li>Copy the signature from this website or your inbox, then in Thunderbird, select Tools > Account Settings.</li><li>In the left pane, click select the account for which you want to use the signature.</li><li>Find the "Signature Text" area.</li><li>Check the "Use HTML" box.</li><li>Paste in your signature inside the text box using Ctrl+V on Windows or Command+V on Mac.</li><li>It will show up as HTML code. This is what it is supposed to do!</li><li>Don\'t worry about the red borders around your signature! When the email is sent it will not show up for the receiver of the email.</li></ol><p><a href="' + this.articleLink() + 'how-to-add-signature-in-thunderbird" target="_blank">View</a> the detailed step by step tutorial with screenshots.</p>',
                windowsmail: '<h5>Windows Mail</h5><ol><li>Copy the signature from this website or your inbox, then in Windows Mail, near the bottom of the left sidebar click the "Gear" icon.</li><li>This will bring up a "Settings" bar, near the middle of it you should find "Signature".</li><li>Windows Mail only supports a single signature. Turn the "Use an Email Signature" to "On".</li><li>Paste the signature into the Edit signature box using Ctrl+V.</li><li>Choose "Save" to keep your new signature and return to your inbox.</li></ol>',
                other: '<h5>Other</h5><ol><li>If your email client is not listed here, it may still support our signatures.</li><li>Your email client must support "HTML" or "Rich Text" signatures. If it only allows plain text signatures then you may be out of luck.</li><li>Look for your settings of your email client and look for "Signature" there should be an area with an editing box where you can paste in a signature.</li><li>If it requires HTML code then go "Back" above and look for the "HTML Code" option.</li></ol>',
                html: '<h5>HTML Code</h5><ol><li>You can get the raw HTML code by pasting your copied signature into any plain text editor or code editor.</li><li>On Windows, one such plain text editor is "Notepad".</li><li>On a Mac, you can use the "TextEdit" program, but you will need to go to the "Format" menu and choose "Make Plain Text".</li><li>The code has no spaces or tabs for best performance in email clients. If you choose you could use a website like <a href="https://codebeautify.org/htmlviewer/" target="_blank">Code Beautify</a> to clean it up.</li></ol>'
            }
        }
    },
    computed: {
        signatureStyles: function() {
            var signatureStyles = {};
            if (this.signature.settings.fontWeight == 'bold') {
                signatureStyles.fontWeight = 'bold';
            }
            if (this.signature.settings.fontStyle == 'italic') {
                signatureStyles.fontStyle = 'italic';
            }
            if (this.signature.settings.fontColor) {
                signatureStyles.color = this.forceHexHash(this.signature.settings.fontColor);
            }
            if (this.signature.settings.fontSize) {
                signatureStyles.fontSize = this.signature.settings.fontSize + 'px';
            }
            if (this.signature.settings.lineHeight == 'tight') {
                signatureStyles.lineHeight = '1.2em';
            }
            if (this.signature.settings.lineHeight == 'comfortable') {
                signatureStyles.lineHeight = '1.5em;';
            }
            if (this.signature.settings.lineHeight == 'generous') {
                signatureStyles.lineHeight = '1.8em;';
            }
            if (this.signature.settings.textAlign) {
                if (this.signature.settings.textAlign !== 'left') {
                    signatureStyles.textAlign = this.signature.settings.textAlign;
                }
            }
            if (this.signature.settings.width) {
                var newWidth = this.signature.settings.width;
                if (this.signature.settings.paddingRight && this.signature.settings.paddingRight > 0) {
                    newWidth = newWidth - this.signature.settings.paddingRight;
                }
                if (this.signature.settings.paddingLeft && this.signature.settings.paddingLeft > 0) {
                    newWidth = newWidth - this.signature.settings.paddingLeft;
                }
                signatureStyles.maxWidth = newWidth + 'px';
            }
            if (this.signature.settings.paddingTop && this.signature.settings.paddingTop > 0) {
                signatureStyles.paddingTop = this.signature.settings.paddingTop + 'px';
            }
            if (this.signature.settings.paddingRight && this.signature.settings.paddingRight > 0) {
                signatureStyles.paddingRight = this.signature.settings.paddingRight + 'px';
            }
            if (this.signature.settings.paddingBottom && this.signature.settings.paddingBottom > 0) {
                signatureStyles.paddingBottom = this.signature.settings.paddingBottom + 'px';
            }
            if (this.signature.settings.paddingLeft && this.signature.settings.paddingLeft > 0) {
                signatureStyles.paddingLeft = this.signature.settings.paddingLeft + 'px';
            }
            if (this.signature.settings.backgroundColor) {
                signatureStyles.backgroundColor = this.forceHexHash(this.signature.settings.backgroundColor);
            }
            if (this.signature.settings.fontFamily) {
                signatureStyles.fontFamily = this.fontFamily(this.signature.settings.fontFamily);
            }
            if (this.signature.settings.alignment) {
                if (this.signature.settings.alignment == 'center') {
                    signatureStyles.marginLeft = 'auto';
                    signatureStyles.marginRight = 'auto';
                }
                if (this.signature.settings.alignment == 'right') {
                    signatureStyles.marginLeft = 'auto';
                }
            }
            return signatureStyles;
        },
        isDesktopSafari: function() {
            var uA = navigator.userAgent;
            var vendor = navigator.vendor;
            if (/Safari/i.test(uA) && /Apple Computer/.test(vendor) && !/Mobi|Android/i.test(uA)) {
                return true;
            } else {
                return false;
            }
        }
    },
    methods:{
        articleLink: function() {
            if (this.load_signature_slug) {
                return '/help/';
            } else if (this.load_instruction_window) {
                return '/help/';
            } else {
                return 'https://signature.email/guides/';
            }
        },
        getChoiceSelectLabel: function(choice) {
            if (choice.label && choice.label !== '') {
                return choice.label;
            } else {
                return choice.value;
            }
        },
        checkForOrgSupportedEmailApps: function() {
            if (this.organization && this.organization.supported_apps && Array.isArray(this.organization.supported_apps)) {
                var new_email_clients = [];
                this.organization.supported_apps.forEach(function (supported_app) {
                    this.email_clients.forEach(function (email_client) {
                        if (email_client.shortname == supported_app) {
                            new_email_clients.push(email_client);
                        }
                    }, new_email_clients);
                }, this, new_email_clients);
                this.email_clients = new_email_clients;
            }
        },
        recalculateSignatureHeightClass: function() {
            if (this.loaded) {
                this.$nextTick(function () {
                    if (this.$refs.signatureArea) {
                        var height = this.$refs.signatureArea.clientHeight;
                        if (height <= 300) {
                            this.signatureHeightClass = 'short';
                        } else if (height > 300 && height <= 500) {
                            this.signatureHeightClass =  'medium';
                        } else if (height > 500) {
                            this.signatureHeightClass =  'tall';
                        }
                    } else {
                        this.signatureHeightClass =  'short';
                    }
                });
            }
        },
        convertEmptyToNull: function(value) {
            if (value === "") {
                return null;
            } else {
                return value;
            }
        },
        IfPropertyExists(object, propName, type) {
            if (object.hasOwnProperty(propName)) {
                return object[propName];
            } else if (type == "Boolean") {
                return false;
            } else {
                return null;
            }
        },
        updateImage: function(image, event) {
            image.url = event.imageurl;
            image.id = event.id;
            image.originalWidth = event.width;
            image.originalHeight = event.height;
            image.placeholderImage = false;
            image.valid = true;
            if (event.originalImageUrl) {
                image.originalUrl = event.originalImageUrl;
            }
            if (event.parentId) {
                image.parentId = event.parentId;
            }
            if (event.cropParentId) {
                image.cropParentId = event.cropParentId;
            }
            if (event.uncroppable && event.uncroppable === true) {
                image.uncroppable = true;
            } else {
                image.uncroppable = false;
            }
        },
        deleteImage: function(image) {
            if (image.placeholderImageUrl) {
                image.placeholderImage = true;
                image.url = image.placeholderImageUrl;
            } else {
                image.url = '';
            }
            image.originalUrl = '';
            image.id = '';
            image.parentId = '';
            image.cropParentId = null;
        },
        checkForEditableRequiredEmail: function(returnType) {
            var hasEditableRequiredEmail = false;
            var editableEmailValue = null;
            this.signature.lines.forEach(function ( line, lineindex ) {
                if (line.type == 'box') {
                    line.lines.forEach(function ( boxline ) {
                        boxline.fields.forEach(function ( thefield, fieldindex ) {
                            if (thefield.type === 'email' && thefield.editable == "value" && thefield.required === true) {
                                if (returnType === 'truefalse') {
                                    hasEditableRequiredEmail = true;
                                } else if (returnType === 'fieldvalue') {
                                    if (thefield.value) {
                                        editableEmailValue = thefield.value;
                                    }
                                }
                            }
                        });
                    }, line, this, hasEditableRequiredEmail, editableEmailValue);
                } else if (line.type == 'columns') {
                    line.columns.forEach(function ( column ) {
                        column.lines.forEach(function ( columnsline ) {
                            if (columnsline.type == 'box') {
                                columnsline.lines.forEach(function ( boxline ) {
                                    boxline.fields.forEach(function ( thefield, fieldindex ) {
                                        if (thefield.type === 'email' && thefield.editable == "value" && thefield.required === true) {
                                            if (returnType === 'truefalse') {
                                                hasEditableRequiredEmail = true;
                                            } else if (returnType === 'fieldvalue') {
                                                if (thefield.value) {
                                                    editableEmailValue = thefield.value;
                                                }
                                            }
                                        }
                                    }, line, this);
                                }, line, this, hasEditableRequiredEmail, editableEmailValue);
                            } else {
                                columnsline.fields.forEach(function ( thefield, fieldindex ) {
                                    if (thefield.type === 'email' && thefield.editable == "value" && thefield.required === true) {
                                        if (returnType === 'truefalse') {
                                            hasEditableRequiredEmail = true;
                                        } else if (returnType === 'fieldvalue') {
                                            if (thefield.value) {
                                                editableEmailValue = thefield.value;
                                            }
                                        }
                                    }
                                }, line, this, hasEditableRequiredEmail, editableEmailValue);
                            }
                        }, line, this, hasEditableRequiredEmail, editableEmailValue);
                    }, line, this, hasEditableRequiredEmail, editableEmailValue);
                } else {
                    line.fields.forEach(function ( thefield, fieldindex ) {
                        if (thefield.type === 'email' && thefield.editable == "value" && thefield.required === true) {
                            if (returnType === 'truefalse') {
                                hasEditableRequiredEmail = true;
                            } else if (returnType === 'fieldvalue') {
                                if (thefield.value) {
                                    editableEmailValue = thefield.value;
                                }
                            }
                        }
                    }, this, hasEditableRequiredEmail, editableEmailValue);
                }
            }, this, hasEditableRequiredEmail, editableEmailValue);
            if (returnType === 'truefalse') {
                this.hasEditableRequiredEmail = hasEditableRequiredEmail;
                return hasEditableRequiredEmail;
            } else if (returnType === 'fieldvalue') {
                return editableEmailValue;
            }
        },
        showInstructions: function(browser) {
            if (this.view == 'designer') {
                if (typeof gtag != "undefined") {
                    gtag('event', 'instructions', {
                        'event_category': 'Designer',
                        'event_label': browser
                    });
                }
            } else {
                if (typeof gtag != "undefined") {
                    gtag('event', 'instructions', {
                        'event_category': 'Generator',
                        'event_label': browser
                    });
                }
            }
            this.chosenInstructions = this.instructions[browser];
        },
        rawSignatureStyles: function() {
            var signatureStyles = '';
            // if (this.signature.settings.fontWeight == 'bold') {
            //     signatureStyles = signatureStyles + 'font-weight:bold;';
            // }
            // if (this.signature.settings.fontColor) {
            //     signatureStyles = signatureStyles + 'color:' + this.forceHexHash(this.signature.settings.fontColor) + ';';
            // }
            // if (this.signature.settings.fontSize) {
            //     signatureStyles = signatureStyles + 'font-size:' + this.signature.settings.fontSize + 'px;';
            // }
            // var lineHeight = null;
            // if (this.signature.settings.fontSize && this.signature.settings.lineHeight == 'tight') {
            //     lineHeight = Math.round(this.signature.settings.fontSize * 1.2);
            //     signatureStyles = signatureStyles + 'line-height:' + lineHeight + 'px;';
            // }
            // if (this.signature.settings.fontSize && this.signature.settings.lineHeight == 'comfortable') {
            //     lineHeight = Math.round(this.signature.settings.fontSize * 1.5);
            //     signatureStyles = signatureStyles + 'line-height:' + lineHeight + 'px;';
            // }
            // if (this.signature.settings.fontSize && this.signature.settings.lineHeight == 'generous') {
            //     lineHeight = Math.round(this.signature.settings.fontSize * 1.8);
            //     signatureStyles = signatureStyles + 'line-height:' + lineHeight + 'px;';
            // }
            // if (this.signature.settings.textAlign) {
            //     if (this.signature.settings.textAlign !== 'left') {
            //         signatureStyles = signatureStyles + 'text-align:' + this.signature.settings.textAlign + ';';
            //     }
            // }
            if (this.signature.settings.width) {
                signatureStyles = signatureStyles + 'max-width:' + this.signature.settings.width + 'px;';
            }
            return signatureStyles;
        },
        rawSignatureBgStyles: function() {
            var signatureBgStyles = '';
            if (this.signature.settings.paddingTop && this.signature.settings.paddingTop > 0) {
                signatureBgStyles = signatureBgStyles + 'padding-top:' + this.signature.settings.paddingTop + 'px;';
            }
            if (this.signature.settings.paddingRight && this.signature.settings.paddingRight > 0) {
                signatureBgStyles = signatureBgStyles + 'padding-right:' + this.signature.settings.paddingRight + 'px;';
            }
            if (this.signature.settings.paddingBottom && this.signature.settings.paddingBottom > 0) {
                signatureBgStyles = signatureBgStyles + 'padding-bottom:' + this.signature.settings.paddingBottom + 'px;';
            }
            if (this.signature.settings.paddingLeft && this.signature.settings.paddingLeft > 0) {
                signatureBgStyles = signatureBgStyles + 'padding-left:' + this.signature.settings.paddingLeft + 'px;';
            }
            if (this.signature.settings.backgroundColor) {
                signatureBgStyles = signatureBgStyles + 'background-color:' + this.forceHexHash(this.signature.settings.backgroundColor) + ';';
            }
            // if (this.signature.settings.fontFamily) {
            //     signatureBgStyles = signatureBgStyles + 'font-family:' + this.fontFamily(this.signature.settings.fontFamily) + ';';
            // }
            return signatureBgStyles;
        },
        createRawSignature: function() {
            var self = this;
            var rawSignature = '<br>';
            if (this.signature.settings.alignment && (this.signature.settings.alignment == 'center' || this.signature.settings.alignment == 'right')) {
                rawSignature = rawSignature + "<table width='100%' border='0' cellspacing='0' cellpadding='0'><tr><td width='100%' align='center'>";
            }
            rawSignature = rawSignature + "<table cellspacing='0' cellpadding='0' border='0' style='border-collapse:separate;table-layout:fixed;overflow-wrap:break-word;word-wrap:break-word;word-break:break-word;" + self.rawSignatureStyles() + "' emb-background-style width='" + self.signatureWidth() + "' " + self.signatureAlign() + "><tbody>";
            var rawSignatureBgStyles = this.rawSignatureBgStyles();
            if (rawSignatureBgStyles) {
                rawSignature = rawSignature + "<tr><td style='" + rawSignatureBgStyles + "'><table cellspacing='0' cellpadding='0' border='0' style='border-collapse:separate;table-layout:fixed;overflow-wrap:break-word;word-wrap:break-word;word-break:break-word;' emb-background-style><tbody>";
            }
            self.signature.lines.forEach(function ( line, lineindex ) {
                if (line.type == 'box') {
                    rawSignature = rawSignature + "<tr><td" + self.boxColumnPadding(line) + "><table cellspacing='0' cellpadding='0' border='0' style='border-collapse:separate;table-layout:fixed;overflow-wrap:break-word;word-wrap:break-word;word-break:break-word;" + self.lineStyle(line) + "' emb-background-style width='" + self.lineWidth(line) + "'><tbody><td style='" + self.boxStyle(line) + "'><table cellspacing='0' cellpadding='0' border='0' style='border-collapse:separate;table-layout:fixed;overflow-wrap:break-word;word-wrap:break-word;word-break:break-word;width:100%;' emb-background-style><tbody>";
                    line.lines.forEach(function ( boxline ) {
                        rawSignature = rawSignature + self.calculatedLine(boxline, line);
                    }, line, self, rawSignature);
                    rawSignature = rawSignature + "</tbody></table></td></tbody></table></td></tr>";
                } else if (line.type == 'columns') {
                    rawSignature = rawSignature + "<tr><td" + self.boxColumnPadding(line) + "><table cellspacing='0' cellpadding='0' border='0' style='" + self.columnsStyle(line) + " border-collapse:separate;table-layout:fixed;overflow-wrap:break-word;word-wrap:break-word;word-break:break-word;' emb-background-style width='" + self.lineWidth(line) + "'><tbody><tr>";
                    line.columns.forEach(function ( column, columnindex ) {
                        rawSignature = rawSignature + "<td style='" + self.singleColumnStyle(column, line) + "' width='" + self.columnWidth(column) + "'><table cellspacing='0' cellpadding='0' border='0' style='border-collapse:separate;table-layout:fixed;overflow-wrap:break-word;word-wrap:break-word;word-break:break-word;' width='100%' emb-background-style><tbody>";
                        column.lines.forEach(function ( columnsline ) {
                            if (columnsline.type == 'box') {
                                rawSignature = rawSignature + "<tr><td" + self.boxColumnPadding(columnsline) + "><table cellspacing='0' cellpadding='0' border='0' style='border-collapse:separate;table-layout:fixed;overflow-wrap:break-word;word-wrap:break-word;word-break:break-word;" + self.lineStyle(columnsline) + "' emb-background-style width='" + self.lineWidth(columnsline) + "'><tbody><td style='" + self.boxStyle(columnsline) + "'><table cellspacing='0' cellpadding='0' border='0' style='border-collapse:separate;table-layout:fixed;overflow-wrap:break-word;word-wrap:break-word;word-break:break-word;width:100%;' emb-background-style><tbody>";
                                columnsline.lines.forEach(function ( boxline ) {
                                    rawSignature = rawSignature + self.calculatedLine(boxline, columnsline, column);
                                }, line, self, rawSignature);
                                rawSignature = rawSignature + "</tbody></table></td></tbody></table></td></tr>";
                            } else {
                                rawSignature = rawSignature + self.calculatedLine(columnsline, column);
                            }
                        }, line, column, self, rawSignature);
                        rawSignature = rawSignature + "</tbody></table></td>";
                    }, self, rawSignature);
                    rawSignature = rawSignature + "</tr></tbody></table></td></tr>";
                } else {
                    rawSignature = rawSignature + self.calculatedLine(line);
                }
            }, self, rawSignature);
            if (rawSignatureBgStyles) {
                rawSignature = rawSignature + "</tbody></table></td></tr>";
            }
            rawSignature = rawSignature + "</tbody></table>";
            if (this.signature.settings.alignment && (this.signature.settings.alignment == 'center' || this.signature.settings.alignment == 'right')) {
                rawSignature = rawSignature + "</td></tr></table>";
            }
            return rawSignature;
        },
        calculatedLine: function(line, parent = null, parentParent = null) {
            var self = this;
            var parentHasBg = self.parentHasBg(parent, parentParent)
            var calculatedLine = '';
            var lineFieldCount = self.displayableFields(line);
            if (lineFieldCount >= 1) {
                calculatedLine = calculatedLine + '<tr><td style="' + self.lineStyle(line) + '">';
                if (!parentHasBg) {
                    calculatedLine = calculatedLine + '<p style="margin:.1px;">';
                }
                line.fields.forEach(function ( field, fieldindex ) {
                    calculatedLine = calculatedLine + self.calculatedField(field, line, lineFieldCount, fieldindex);
                }, line, self, calculatedLine);
                if (!parentHasBg) {
                    calculatedLine = calculatedLine + '</p>';
                }
                calculatedLine = calculatedLine + '</td></tr>';
            }
            return calculatedLine;
        },
        parentHasBg: function(parent = null, parentParent = null) {
            if (this.signature.settings.backgroundColor && this.signature.settings.backgroundColor !== '') {
                return true;
            } else if (parent && parent.hasOwnProperty('backgroundColor') && parent.backgroundColor !== '') {
                return true;
            } else if (parentParent && parentParent.hasOwnProperty('backgroundColor') && parentParent.backgroundColor !== '') {
                return true;
            } else {
                return false;
            }
        },
        displayableFields: function(line) {
            var self = this;
            var displayableFields = 0;
            if (line.fields.length > 0) {
                line.fields.forEach(function ( field, fieldindex ) {
                    if (self.fieldOptionalAndNotUsed(field) || self.fieldDoesNotHaveBeforeAfter(field, line, fieldindex) || (field.hasOwnProperty('editable') && field.editable == 'displaytoggle' && field.display == false)) {
                        // do not increment
                    } else {
                        displayableFields++;
                    }
                }, line, displayableFields);
            }
            return displayableFields;
        },
        autoCompleteType: function(field) {
            if (field.type == 'text' && field.slug == 'whole_address') {
                return 'street-address';
            } else if (field.type == 'text' && field.slug == 'address1') {
                return 'address-line1';
            } else if (field.type == 'text' && field.slug == 'address2') {
                return 'address-line2';
            } else if (field.type == 'text' && field.slug == 'city') {
                return 'address-level2';
            } else if (field.type == 'text' && field.slug == 'state') {
                return 'address-level1';
            } else if (field.type == 'text' && field.slug == 'zip') {
                return 'postal-code';
            } else if (field.type == 'text' && field.slug == 'country') {
                return 'country-name';
            } else if (field.type == 'email' && field.slug == 'email') {
                return 'email';
            } else if (field.type == 'phone') {
                return 'tel';
            } else if (field.type == 'text' && field.slug == 'full_name') {
                return 'name';
            } else if (field.type == 'text' && field.slug == 'first_name') {
                return 'given-name';
            } else if (field.type == 'text' && field.slug == 'last_name') {
                return 'family-name';
            } else if (field.type == 'text' && field.slug == 'company_name') {
                return 'organization';
            } else if (field.type == 'text' && field.slug == 'title') {
                return 'organization-title';
            } else {
                return false;
            }
        },
        findLargestFontSizeInLine: function(line) {
            var self = this;
            var largestFontSize = null;
            if (line.fields.length > 0) {
                line.fields.forEach(function ( field ) {
                    if (self.fieldOptionalAndNotUsed(field) || (field.hasOwnProperty('editable') && field.editable == 'displaytoggle' && field.display == false)) {
                        // do not increment
                    } else {
                        if (field && field.fontSize) {
                            if (!largestFontSize) {
                                largestFontSize = field.fontSize;
                            } else if (largestFontSize > field.fontSize) {
                                largestFontSize = field.fontSize;
                            }
                        }
                    }
                }, line, largestFontSize);
            }
            return largestFontSize;
        },
        getImageUrl(type = 'image', organization = null) {
            if (organization == null && this.organization) {
                organization = this.organization;
            }
            if (type == 'image') {
                if (organization && organization.slug) {
                    return 'https://' + organization.slug + '.img.email';
                } else {
                    return 'https://image.signature.email';
                }
            } else if (type == 'icon') {
                if (this.load_env == 'development') {
                    return 'http://signatureemailicon.lndo.site';
                } else {
                    if (organization && organization.slug) {
                        return 'https://' + organization.slug + '.icns.email';
                    } else {
                        return 'https://icon.signature.email';
                    }
                }
                
            }
        },
        fieldOptionalAndNotUsed: function(field) {
            if (field.hasOwnProperty('required')) {
                if (field.required === false) {
                    if (field.type == 'social' || field.type == 'link' || field.type == 'button' || field.type == 'newbutton') {
                        if (field.link == '') {
                            return true;
                        } else {
                            return false;
                        }
                    } else if (field.type == 'image') {
                        if (field.hasOwnProperty('editable') && field.editable == 'link') {
                            if (field.link == '') {
                                return true;
                            } else {
                                return false;
                            }
                        } else {
                            if (field.url == '') {
                                return true;
                            } else {
                                return false;
                            }
                        }
                    } else {
                        if (field.value === '') {
                            return true;
                        } else {
                            return false;
                        }
                    }
                } else {
                    return false;
                }
            } else {
                return false;
            }
        },
        calculatedField: function(field, line, lineFieldCount, fieldindex) {
            var self = this;
            if (self.fieldOptionalAndNotUsed(field) || self.fieldDoesNotHaveBeforeAfter(field, line, fieldindex) || (field.hasOwnProperty('editable') && field.editable == 'displaytoggle' && field.display == false)) {
                return '';
            } else {
                if (field.type == 'image' || field.type == 'social' || field.type == 'button' || field.type == 'icon') {
                    return this.calculatedValue(field, field.slug, line, lineFieldCount, fieldindex);
                } else {
                    var fieldStyle = this.fieldStyle(field);
                    if (fieldStyle === '') {
                        return this.calculatedValue(field, field.slug, line, lineFieldCount, fieldindex);
                    } else {
                        return "<span style='" + fieldStyle + "'>" + this.calculatedValue(field, field.slug, line, lineFieldCount, fieldindex) + "</span>";
                    }
                }
            }
        },
        fieldDoesNotHaveBeforeAfter: function(field, line, fieldindex) {
            //This field requires a before and after field, and this determines whether it does not have one or the other
            if (field.type == 'separator' || field.type == 'spacer') {
                if (field.requiresBeforeAfter === true) {
                    var fieldBeforeIndex = fieldindex - 1;
                    var fieldBeforeValue = '';
                    if(typeof line.fields[fieldBeforeIndex] === 'undefined') {
                        fieldBeforeValue = 'none';
                    } else {
                        var fieldBefore = line.fields[fieldBeforeIndex];
                        if (this.fieldOptionalAndNotUsed(fieldBefore) === false) {
                            if (fieldBefore.hasOwnProperty('editable') && fieldBefore.editable == 'displaytoggle' && fieldBefore.display === true) {
                                fieldBeforeValue = this.calculatedValue(fieldBefore, fieldBefore.slug, line, 1, fieldBeforeIndex);
                            } else if (fieldBefore.hasOwnProperty('editable') && fieldBefore.editable == 'displaytoggle' && fieldBefore.display === false) {
                                //nothing
                            } else {
                                fieldBeforeValue = this.calculatedValue(fieldBefore, fieldBefore.slug, line, 1, fieldBeforeIndex);
                            }
                        }
                    }
                    var fieldAfterIndex = fieldindex + 1;
                    var fieldAfterValue = '';
                    if(typeof line.fields[fieldAfterIndex] === 'undefined') {
                        fieldAfterValue = 'none';
                    } else {
                        var fieldAfter = line.fields[fieldAfterIndex];
                        if (this.fieldOptionalAndNotUsed(fieldAfter) === false) {
                            if (fieldAfter.hasOwnProperty('editable') && fieldAfter.editable == 'displaytoggle' && fieldAfter.display === true) {
                                fieldAfterValue = this.calculatedValue(fieldAfter, fieldAfter.slug, line, 1, fieldAfterIndex);
                            } else if (fieldAfter.hasOwnProperty('editable') && fieldAfter.editable == 'displaytoggle' && fieldAfter.display === false) {
                                //nothing
                            } else {
                                fieldAfterValue = this.calculatedValue(fieldAfter, fieldAfter.slug, line, 1, fieldAfterIndex);
                            }
                        }
                    }
                    if ((fieldBeforeValue !== 'none' && fieldAfterValue !== 'none') && fieldBeforeValue == '' || fieldAfterValue == '') {
                        return true;
                    }
                }
            }
            return false;
        },
        calculatedValue: function(field, key, line, lineFieldCount, fieldindex) {
            var value = '';
            if ((field.before == 'separator' || field.before == 'text') && field.beforeText && this.placeholderValue(field)) {
                var beforeSpanBefore = '';
                var beforeStyle = '';
                var beforeSpanAfter = '';
                if (field.beforeTextWeight == 'bold') {
                    beforeStyle = beforeStyle + 'font-weight:bold;';
                } else if (field.beforeTextWeight == 'normal') {
                    beforeStyle = beforeStyle + 'font-weight:normal;';
                }
                if (field.beforeColor) {
                    beforeStyle = beforeStyle + 'color:' + this.forceHexHash(field.beforeColor) + ';';
                }
                if (beforeStyle !== '') {
                    beforeSpanBefore = '<span style="' + beforeStyle + '">';
                    beforeSpanAfter = '</span>';
                }
                value = value + beforeSpanBefore + field.beforeText + beforeSpanAfter + ' ';
            }
            if (field.before == 'icon' && field.beforeIconSet && field.beforeIconStyle && field.beforeIcon && this.placeholderValue(field)) {
                var iconColor = this.getIconColor(field.beforeIconColorType, field.beforeColor);
                iconColor = iconColor.replace("#", "");
                if (!iconColor) {
                    iconColor = '666666';
                }
                var iconWidth = null;
                var iconHeight = null;
                if (field.beforeIconOrigWidth > field.beforeIconOrigHeight) {
                    iconWidth = field.beforeIconSize;
                    iconHeight = Math.ceil((field.beforeIconSize * field.beforeIconOrigHeight) / field.beforeIconOrigWidth);
                } else {
                    iconHeight = field.beforeIconSize;
                    iconWidth = Math.ceil((field.beforeIconSize * field.beforeIconOrigWidth) / field.beforeIconOrigHeight);
                }
                var beforeIconUrl = '';
                if (this.signature.settings.selfHostedImages && field.beforeIconSelfHosted) {
                    if (field.beforeIconSelfHostedWidth !== '') {
                        iconWidth = field.beforeIconSelfHostedWidth;
                    }
                    if (field.beforeIconSelfHostedHeight !== '') {
                        iconHeight = field.beforeIconSelfHostedHeight;
                    }
                    if (field.beforeIconSelfHostedUrl && field.beforeIconSelfHostedUrl !== '') {
                        beforeIconUrl = field.beforeIconSelfHostedUrl;
                    } else {
                        beforeIconUrl = this.getImageUrl() + '/placeholders/placeholder-icon.gif';
                    }
                } else {
                    beforeIconUrl = this.getImageUrl('icon') + '/icon/' + field.beforeIconSet + '-' + field.beforeIconStyle + '-' + field.beforeIconSize + '-' + field.beforeIcon + '-' + iconColor + '.png';
                }
                value = value + '<img src="' + beforeIconUrl + '" width="' + iconWidth + '" height="' + iconHeight + '" hspace="4" style="margin-right:4px;border:0px;vertical-align:middle;" border="0" nosend="1" alt="" />&nbsp;';
            }
            if (field.type == 'phone') {
                var linkColor = '';
                if (field.fontColor) {
                    linkColor = this.forceHexHash(field.fontColor);
                } else {
                    linkColor = this.forceHexHash(this.signature.settings.linkColor);
                }
                if (this.previewActive) {
                    value = value + '<a href="tel:' + this.removeSpaces(this.placeholderValue(field)) + '" style="color:' + linkColor + ';text-decoration:none;" target="_blank">' + this.placeholderValue(field) + '</a>';
                } else {
                    value = value + '<span style="color:' + this.forceHexHash(linkColor) + '">' + this.placeholderValue(field) + '</span>';
                }
            }
            if (field.type == 'link') {
                if (field.link) {
                    var linkColor = '';
                    var linkWithHttp = field.link;
                    if (linkWithHttp.lastIndexOf('http', 0) !== 0 && linkWithHttp.lastIndexOf('tel:', 0) !== 0 && linkWithHttp.lastIndexOf('mailto:', 0) !== 0) {
                        linkWithHttp = 'https://' + linkWithHttp;
                    }
                    if (field.fontColor) {
                        linkColor = this.forceHexHash(field.fontColor);
                    } else {
                        linkColor = this.forceHexHash(this.signature.settings.linkColor);
                    }
                    if (this.previewActive) {
                        value = value + '<a href="' + linkWithHttp + '" style="color:' + linkColor + ';text-decoration:none;" target="_blank">' + this.placeholderValue(field) + '</a>';
                    } else {
                        value = value + '<span style="color:' + linkColor + '">' + this.placeholderValue(field) + '</span>';
                    }
                } else {
                    value = value + this.placeholderValue(field);
                }
            }
            if (field.type == 'email') {
                var linkColor = '';
                if (field.fontColor) {
                    linkColor = this.forceHexHash(field.fontColor);
                } else {
                    linkColor = this.forceHexHash(this.signature.settings.linkColor);
                }
                if (this.previewActive) {
                    value = value + '<a href="mailto:' + this.placeholderValue(field) + '" style="color:' + linkColor + ';text-decoration:none;" target="_blank">' + this.placeholderValue(field) + '</a>';
                } else {
                    value = value + '<span style="color:' + linkColor + '">' + this.placeholderValue(field) + '</span>';
                }
                
            }
            if (field.type == 'social') {
                var size = null;
                if (this.signature.settings.socialIconSize == 'small') {
                    size = '22';
                } else if (this.signature.settings.socialIconSize == 'large') {
                    size = '42';
                } else {
                    size = '32';
                }
                var width = size;
                var height = size;
                var linkWithHttp = field.link;
                if (linkWithHttp !== '' && linkWithHttp.lastIndexOf('http', 0) !== 0 && linkWithHttp.lastIndexOf('tel:', 0) !== 0 && linkWithHttp.lastIndexOf('mailto:', 0) !== 0) {
                    linkWithHttp = 'https://' + linkWithHttp;
                }
                //if (this.copyCodeMode === true) {
                    var bgColor = this.getSocialColor(field, 'background');
                    bgColor = bgColor.replace("#", "");
                    var iconColor = this.getSocialColor(field, 'icon');
                    iconColor = iconColor.replace("#", "");
                    if (this.previewActive) {
                        value = value + '<a href="' + linkWithHttp + '" target="_blank" style="display:inline-block;padding-right:4px;vertical-align:middle;">';
                    } else {
                        value = value + '<span style="display:inline-block;padding-right:4px;vertical-align:middle;">';
                    }
                    var iconUrl = '';
                    if (this.signature.settings.selfHostedImages && field.selfHosted) {
                        if (field.selfHostedWidth !== '') {
                            width = field.selfHostedWidth;
                        }
                        if (field.selfHostedHeight !== '') {
                            height = field.selfHostedHeight;
                        }
                        if (field.selfHostedUrl && field.selfHostedUrl !== '') {
                            iconUrl = field.selfHostedUrl;
                        } else {
                            iconUrl = this.getImageUrl() + '/placeholders/placeholder-icon.gif';
                        }
                    } else {
                        iconUrl = this.getImageUrl('icon') + '/social/' + key + '-' + this.signature.settings.socialIconShape + '-' + this.signature.settings.socialIconSize + '-' + bgColor + '-' + iconColor + '.png';
                    }
                    value = value + '<img src="' + iconUrl + '" width="' + width + '" height="' + height + '" style="border:0px;display:inline-block;" border="0" nosend="1" alt="' + field.label + '" />';
                    if (this.previewActive) {
                        value = value + '</a>';
                    } else {
                        value = value + '</span>';
                    }
                //} else {
                //     value = value + '<a href="' + field.link + '" style="' + this.socialStyle(field, key) + '"><img src="/img/social/' + key + '-white-' + size + '.png" width="' + size + '" height="' + size + '"></a><style>svg .background { background-color: }';
                // }
                
            }
            if (field.type == 'button') {
                var linkWithHttp = field.link;
                var width = field.width;
                var height = field.height;
                if (linkWithHttp !== '' && field.slug == 'emailbutton' && linkWithHttp.indexOf('@') !== -1 && linkWithHttp.lastIndexOf('mailto:', 0) !== 0) {
                    linkWithHttp = 'mailto:' + linkWithHttp;
                } else if (linkWithHttp !== '' && linkWithHttp.lastIndexOf('http', 0) !== 0 && linkWithHttp.lastIndexOf('tel:', 0) !== 0 && linkWithHttp.lastIndexOf('mailto:', 0) !== 0) {
                    linkWithHttp = 'https://' + linkWithHttp;
                }
                var bgColor = '666666';
                if (field.backgroundColorType === 'default') {
                    bgColor = field.defaultBackground;
                } if (field.backgroundColorType == 'black') {
                    bgColor = '#000000';
                } else if (field.backgroundColorType == 'gray') {
                    bgColor = '#666666';
                } else if (field.backgroundColorType == 'linkcolor') {
                    bgColor = this.signature.settings.linkColor;
                } else if (field.backgroundColorType == 'other' && field.backgroundColor && field.backgroundColor !== '') {
                    bgColor = field.backgroundColor;
                }
                bgColor = bgColor.replace("#", "");
                if (this.previewActive) {
                    value = value + '<a href="' + linkWithHttp + '" target="_blank" style="display:inline-block;padding-right:4px;vertical-align:middle;">';
                } else {
                    value = value + '<span style="display:inline-block;padding-right:4px;vertical-align:middle;">';
                }
                var buttonUrl = '';
                if (this.signature.settings.selfHostedImages && field.selfHosted) {
                    if (field.selfHostedWidth !== '') {
                        width = field.selfHostedWidth;
                    }
                    if (field.selfHostedHeight !== '') {
                        height = field.selfHostedHeight;
                    }
                    if (field.selfHostedUrl && field.selfHostedUrl !== '') {
                        buttonUrl = field.selfHostedUrl;
                    } else {
                        buttonUrl = this.getImageUrl() + '/placeholders/placeholder-image.gif';
                    }
                } else {
                    buttonUrl = this.getImageUrl('icon') + '/button/' + field.chosen + '-' + field.chosenSize + '-' + bgColor + '-dark-' + field.edges + '.png';
                }
                value = value + '<img src="' + buttonUrl + '" width="' + width + '" height="' + height + '" style="border:0px;display:inline-block;" border="0" nosend="1" alt="' + field.textValue + '" />';
                if (this.previewActive) {
                    value = value + '</a>';
                } else {
                    value = value + '</span>';
                }
            }
            if (field.type == 'newbutton') {
                var linkWithHttp = field.link;
                var width = field.width;
                var height = field.height;
                if (linkWithHttp !== '' && field.slug == 'emailbutton' && linkWithHttp.indexOf('@') !== -1 && linkWithHttp.lastIndexOf('mailto:', 0) !== 0) {
                    linkWithHttp = 'mailto:' + linkWithHttp;
                } else if (linkWithHttp !== '' && linkWithHttp.lastIndexOf('http', 0) !== 0 && linkWithHttp.lastIndexOf('tel:', 0) !== 0 && linkWithHttp.lastIndexOf('mailto:', 0) !== 0) {
                    linkWithHttp = 'https://' + linkWithHttp;
                }
                //Deal with background color
                var bgColor = '666666';
                if (field.backgroundColorType === 'default') {
                    bgColor = field.defaultBackground;
                } if (field.backgroundColorType == 'black') {
                    bgColor = '#000000';
                } else if (field.backgroundColorType == 'gray') {
                    bgColor = '#666666';
                } else if (field.backgroundColorType == 'trans') {
                    bgColor = 'trans';
                } else if (field.backgroundColorType == 'linkcolor') {
                    bgColor = this.signature.settings.linkColor;
                } else if (field.backgroundColorType == 'other' && field.backgroundColor && field.backgroundColor !== '') {
                    bgColor = field.backgroundColor;
                }
                bgColor = bgColor.replace("#", "");
                //Deal with icon color
                var iconColor = 'FFFFFF';
                if (field.iconTextColorType === 'white') {
                    iconColor = 'FFFFFF';
                } else if (field.iconTextColorType === 'gray') {
                    iconColor = '666666';
                } else if (field.iconTextColorType === 'darkgray') {
                    iconColor = '333333';
                } else if (field.iconTextColorType == 'linkcolor') {
                    iconColor = this.signature.settings.linkColor;
                } else if (field.iconTextColorType == 'other' && field.iconColor && field.iconColor !== '') {
                    iconColor = field.iconColor;
                }
                iconColor = iconColor.replace("#", "");
                //Deal with text color
                var textColor = 'FFFFFF';
                if (field.iconTextColorType === 'white') {
                    textColor = 'FFFFFF';
                } else if (field.iconTextColorType === 'gray') {
                    textColor = '666666';
                } else if (field.iconTextColorType === 'darkgray') {
                    textColor = '333333';
                } else if (field.iconTextColorType == 'linkcolor') {
                    textColor = this.signature.settings.linkColor;
                } else if (field.iconTextColorType == 'other' && field.textColor && field.textColor !== '') {
                    textColor = field.textColor;
                }
                textColor = textColor.replace("#", "");
                if (this.previewActive) {
                    value = value + '<a href="' + linkWithHttp + '" target="_blank" style="display:inline-block;padding-right:4px;vertical-align:middle;">';
                } else {
                    value = value + '<span style="display:inline-block;padding-right:4px;vertical-align:middle;">';
                }
                var buttonUrl = '';
                if (this.signature.settings.selfHostedImages && field.selfHosted) {
                    if (field.selfHostedWidth !== '') {
                        width = field.selfHostedWidth;
                    }
                    if (field.selfHostedHeight !== '') {
                        height = field.selfHostedHeight;
                    }
                    if (field.selfHostedUrl && field.selfHostedUrl !== '') {
                        buttonUrl = field.selfHostedUrl;
                    } else {
                        buttonUrl = this.getImageUrl() + '/placeholders/placeholder-image.gif';
                    }
                } else {
                    buttonUrl = this.getImageUrl('icon') + '/buttons/' + field.imageSlug + '-' + field.chosenSize + '-' + bgColor + '-' + iconColor + '-' + textColor + '-' + field.edges + '-' + field.side + '.png';
                }
                value = value + '<img src="' + buttonUrl + '" width="' + width + '" height="' + height + '" style="border:0px;display:inline-block;" border="0" nosend="1" alt="' + field.textValue + '" />';
                if (this.previewActive) {
                    value = value + '</a>';
                } else {
                    value = value + '</span>';
                }
            }
            if (field.type == 'select') {
                var indexValue = field.value;
                var shouldDisplay = true;
                var chosenOption = null;
                if (field.value === '' && (this.previewActive === false || field.required === true)) {
                    indexValue = 0;
                } else if (field.value === '' && field.required === false) {
                    shouldDisplay = false;
                }
                if (shouldDisplay || this.previewActive) {
                    chosenOption = field.choices[indexValue];
                }
                if (shouldDisplay && chosenOption) {
                    if (chosenOption.link) {
                        var linkColor = '';
                        var linkWithHttp = chosenOption.link;
                        if (linkWithHttp.lastIndexOf('http', 0) !== 0 && linkWithHttp.lastIndexOf('tel:', 0) !== 0 && linkWithHttp.lastIndexOf('mailto:', 0) !== 0) {
                            linkWithHttp = 'https://' + linkWithHttp;
                        }
                        if (field.fontColor) {
                            linkColor = this.forceHexHash(field.fontColor);
                        } else {
                            linkColor = this.forceHexHash(this.signature.settings.linkColor);
                        }
                        if (this.previewActive) {
                            value = value + '<a href="' + linkWithHttp + '" style="color:' + linkColor + ';text-decoration:none;" target="_blank">' + this.placeholderValue(field) + '</a>';
                        } else {
                            value = value + '<span style="color:' + linkColor + '">' + this.placeholderValue(field) + '</span>';
                        }
                    } else {
                        value = value + this.placeholderValue(field);
                    }
                }
            }
            if (field.type == 'image' || field.type == 'selectimage') {
                var imageField = field;
                var shouldDisplay = true;
                if (field.type == 'selectimage') {
                    var indexValue = field.value;
                    if (field.value === '') {
                        indexValue = 0;
                    } else if (field.value === '' && field.required === false) {
                        shouldDisplay = false;
                    }
                    if (shouldDisplay || this.previewActive) {
                        imageField = field.choices[indexValue];
                    }
                }
                if ((shouldDisplay || this.previewActive) && imageField) {
                    var linkWithHttp = imageField.link;
                    var url = "";
                    var height = "";
                    var heightTag = "";
                    if (linkWithHttp !== '' && linkWithHttp.lastIndexOf('http', 0) !== 0 && linkWithHttp.lastIndexOf('tel:', 0) !== 0 && linkWithHttp.lastIndexOf('mailto:', 0) !== 0) {
                        linkWithHttp = 'https://' + linkWithHttp;
                    }
                    var altText = '';
                    if (imageField.hasOwnProperty('alt') && imageField.alt !== '') {
                        altText = imageField.alt;
                    }
                    var width = imageField.width;
                    if (this.signature.settings.selfHostedImages && imageField.selfHosted && imageField.selfHostedWidth) {
                        width = imageField.selfHostedWidth;
                    }
                    if (width == null || width == '') {
                        width = 100;
                    }
                    if (this.signature.settings.selfHostedImages && imageField.selfHosted && imageField.selfHostedHeight) {
                        height = imageField.selfHostedHeight;
                        heightTag = ' height="' + imageField.selfHostedHeight + '"';
                    } else if (width && imageField.originalWidth && imageField.originalHeight) {
                        height = Math.round((imageField.originalHeight * width) / imageField.originalWidth);
                        heightTag = ' height="' + height + '"';
                    }
                    if (imageField.link && this.previewActive) {
                        if (lineFieldCount == 1) {
                            value = value + '<a href="' + linkWithHttp + '" style="border:0px;display:block;height:' + height + 'px;" target="_blank">';
                        } else {
                            value = value + '<a href="' + linkWithHttp + '" style="border:0px;display:inline-block;vertical-align:middle;" target="_blank">';
                        }
                    }
                    var imgDisplay = 'inline-block';
                    var margin = '';
                    var verticalAlign = '';
                    if (lineFieldCount == 1 && this.previewActive) {
                        imgDisplay = 'block';
                        if (line && line.textAlign) {
                            if (line.textAlign == 'center') {
                                margin = 'margin-right:auto;margin-left:auto;';
                            } else if (line.textAlign == 'right') {
                                margin = 'margin-left:auto;';
                            }
                        }
                    } else if (this.previewActive && !imageField.link) {
                        verticalAlign = 'vertical-align:middle;';
                    } 
                    if (this.signature.settings.selfHostedImages && imageField.selfHosted && imageField.selfHostedUrl) {
                        url = imageField.selfHostedUrl;
                    } else if (imageField.url) {
                        url = this.getImageUrl() + "/" + imageField.url;
                    }
                    if (url) {
                        value = value + '<img src="' + url + '" width="' + width + '"' + heightTag + ' style="display:'+ imgDisplay + ';' + verticalAlign + margin + 'border:0px;" border="0" nosend="1" alt="' + altText + '" />';
                    } else {
                        value = value + '<img src="' + this.getImageUrl() + '/placeholders/placeholder-image.gif" width="' + width + '" style="display:'+ imgDisplay + ';' + verticalAlign + margin + 'border:0px;" border="0" nosend="1" alt="" />';
                    }
                    if (imageField.link && this.previewActive) {
                        value = value + '</a>';
                    }
                }
            }
            if (field.type == 'icon') {
                var linkWithHttp = field.link;
                if (linkWithHttp !== '' && linkWithHttp.lastIndexOf('http', 0) !== 0 && linkWithHttp.lastIndexOf('tel:', 0) !== 0 && linkWithHttp.lastIndexOf('mailto:', 0) !== 0) {
                    linkWithHttp = 'https://' + linkWithHttp;
                }
                var verticalAlign = '';
                if (!field.link) {
                    verticalAlign = 'vertical-align:middle;';
                } 
                if (field.link && this.previewActive) {
                    value = value + '<a href="' + linkWithHttp + '" style="border:0px;display:inline-block;vertical-align:middle;" target="_blank" >';
                }
                var iconColor = this.getIconColor(field.iconColorType, field.iconColor);
                iconColor = iconColor.replace("#", "");
                if (!iconColor) {
                    iconColor = '666666';
                }
                var iconWidth = null;
                var iconHeight = null;
                var icon = null;
                var set = null;
                var style = null;
                if (field.iconOrigWidth > field.iconOrigHeight) {
                    iconWidth = field.iconSize;
                    iconHeight = Math.ceil((field.iconSize * field.iconOrigHeight) / field.iconOrigWidth);
                } else {
                    iconHeight = field.iconSize;
                    iconWidth = Math.ceil((field.iconSize * field.iconOrigWidth) / field.iconOrigHeight);
                }
                if (!field.icon) {
                    icon = 'paperplane';
                    set = 'fa';
                    style = 'solid';
                    iconWidth = field.iconSize;
                    iconHeight = field.iconSize;
                } else {
                    icon = field.icon;
                    set = field.iconSet;
                    style = field.iconStyle;
                }
                var iconUrl = '';
                if (this.signature.settings.selfHostedImages && field.selfHosted) {
                    if (field.selfHostedWidth !== '') {
                        iconWidth = field.selfHostedWidth;
                    }
                    if (field.selfHostedHeight !== '') {
                        iconHeight = field.selfHostedHeight;
                    }
                    if (field.selfHostedUrl && field.selfHostedUrl !== '') {
                        iconUrl = field.selfHostedUrl;
                    } else {
                        iconUrl = this.getImageUrl() + '/placeholders/placeholder-icon.gif';
                    }
                } else {
                    iconUrl = this.getImageUrl('icon') + '/icon/' + set + '-' + style + '-' + field.iconSize + '-' + icon + '-' + iconColor + '.png';
                }
                value = value + '<img src="' + iconUrl + '" width="' + iconWidth + '" height="' + iconHeight + '" style="padding-right:4px;border:0px;' + verticalAlign + 'display:inline-block;" border="0" nosend="1" alt="" />';
                // } else {
                //     value = value + '<img src="https://icon.signature.email/icon/fa-solid-' + field.iconSize + '-paperplane-666666.png" width="' + field.iconSize + '" height="' + field.iconSize + '" hspace="4" style="margin-right:4px;border:0px;vertical-align:middle;" border="0">';
                // }
                if (field.link && this.previewActive) {
                    value = value + '</a>';
                }
            }
            // if (field.type == 'box') {
            //     value = value + '<table style="border-collapse: separate;table-layout: fixed;Margin-left: auto;Margin-right: auto;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: #ffffff;" align="center" emb-background-style><tbody><tr><td style="font-size: 15px;line-height: 21px;padding: 0;text-align: left;vertical-align: top;color: #4d4d4d;font-family: sans-serif;" width="300"><div class="mobile-side-margin mobile-vertical-margin" style="Margin-left: 15px;Margin-right: 15px;Margin-bottom: 15px;Margin-top: 15px;"></div></td></tr></table>';
            // }
            if (field.type == 'text' || field.type == 'textarea') {
                value = value + this.placeholderValue(field);
            }
            if (field.type == 'spacer') {
                var spacerImageUrl = '';
                if (this.signature.settings.selfHostedImages && field.selfHosted && field.selfHostedUrl && field.selfHostedUrl !== '') {
                    spacerImageUrl = field.selfHostedUrl;
                } else {
                    spacerImageUrl = this.getImageUrl() + '/img/spacer.gif';
                }
                value = value + "<img src='" + spacerImageUrl + "' height='2' width='" + field.width + "' style='height:2px;width:" + field.width + "px;' alt='' />";
            }
            if (field.type == 'separator') {
                if (field.hasOwnProperty('spacesBefore') && field.spacesBefore > 0) {
                    var spacesBefore = '';
                    for (let i = 0; i < field.spacesBefore; i++) {
                        value = value + '&nbsp;';
                    }
                }
                value = value + this.placeholderValue(field);
                if (field.hasOwnProperty('spacesAfter') && field.spacesAfter > 0) {
                    var spacesAfter = '';
                    for (let i = 0; i < field.spacesAfter; i++) {
                        value = value + '&nbsp;';
                    }
                }
            }
            if ((field.after == 'separator' || field.after == 'text') && field.afterText && this.placeholderValue(field)) {
                var afterSpanBefore = '<span>';
                var afterStyle = '';
                var afterSpanAfter = '</span>';
                if (field.afterTextWeight == 'bold') {
                    afterStyle = afterStyle + 'font-weight:bold;';
                } else if (field.afterTextWeight == 'normal') {
                    afterStyle = afterStyle + 'font-weight:normal;';
                }
                if (field.afterColor) {
                    afterStyle = afterStyle + 'color:' + this.forceHexHash(field.afterColor) + ';';
                }
                if (afterStyle !== '') {
                    afterSpanBefore = '<span style="' + afterStyle + '">';
                }
                value = value + ' ' + afterSpanBefore + field.afterText + afterSpanAfter;
            }
            if (field.after == 'icon' && field.afterIconSet && field.afterIconStyle && field.afterIcon && this.placeholderValue(field)) {
                var iconColor = this.getIconColor(field.afterIconColorType, field.afterColor);
                iconColor = iconColor.replace("#", "");
                if (!iconColor) {
                    iconColor = '666666';
                }
                var iconWidth = null;
                var iconHeight = null;
                if (field.afterIconOrigWidth > field.afterIconOrigHeight) {
                    iconWidth = field.afterIconSize;
                    iconHeight = Math.ceil((field.afterIconSize * field.afterIconOrigHeight) / field.afterIconOrigWidth);
                } else {
                    iconHeight = field.afterIconSize;
                    iconWidth = Math.ceil((field.afterIconSize * field.afterIconOrigWidth) / field.afterIconOrigHeight);
                }
                var afterIconUrl = '';
                if (this.signature.settings.selfHostedImages && field.afterIconSelfHosted) {
                    if (field.afterIconSelfHostedWidth !== '') {
                        iconWidth = field.afterIconSelfHostedWidth;
                    }
                    if (field.afterIconSelfHostedHeight !== '') {
                        iconHeight = field.afterIconSelfHostedHeight;
                    }
                    if (field.afterIconSelfHostedUrl && field.afterIconSelfHostedUrl !== '') {
                        afterIconUrl = field.afterIconSelfHostedUrl;
                    } else {
                        afterIconUrl = this.getImageUrl() + '/placeholders/placeholder-icon.gif';
                    }
                } else {
                    afterIconUrl = this.getImageUrl('icon') + '/icon/' + field.afterIconSet + '-' + field.afterIconStyle + '-' + field.afterIconSize + '-' + field.afterIcon + '-' + iconColor + '.png';
                }
                value = value + '&nbsp;<img src="' + afterIconUrl + '" width="' + iconWidth + '" height="' + iconHeight + '" hspace="4" style="margin-left:4px;border:0px;vertical-align: middle;" border="0" nosend="1" alt="" />';
            }
            if (this.previewActive) {
                if (field.type !== 'image' && field.type !== 'social' && (fieldindex + 1) !== lineFieldCount) {
                    value = value + ' ';
                }
            } else {
                value = value + ' ';
            }
            return value;
        },
        socialStyle(field, key) {
            var socialStyle = 'display:inline-block;';

            if (this.signature.settings.socialIconSize == 'large') {
                socialStyle = socialStyle + 'width:40px;height:40px;mso-line-height-rule:exactly;line-height:38px;';
            } else if (this.signature.settings.socialIconSize == 'small') {
                socialStyle = socialStyle + 'width:20px;height:20px;mso-line-height-rule:exactly;line-height:18px;';
            } else {
                socialStyle = socialStyle + 'width:30px;height:30px;mso-line-height-rule:exactly;line-height:28px;';
            }

            if (this.signature.settings.socialIconShape == 'circle') {
                socialStyle = socialStyle + 'border-radius:50%;';
            } else if (this.signature.settings.socialIconShape == 'rounded') {
                socialStyle = socialStyle + 'border-radius:5px;';
            }

            socialStyle = socialStyle + 'background-color:#' + this.getSocialColor(field, 'background') + ';';

            return socialStyle;
        },
        getIconColor: function(type, color) { 
            if (type && (typeof type === 'string' || type instanceof String)) {
                if (type == 'black') {
                    return '#000000';
                } else if (type == 'white') {
                    return '#FFFFFF';
                } else if (type == 'lightgray') {
                    return '#aaaaaa';
                } else if (type == 'gray') {
                    return '#666666';
                } else if (type == 'darkgray') {
                    return '#333333';
                } else if (type == 'linkcolor') {
                    return this.signature.settings.linkColor;
                } else if (type == 'other') {
                    if (color) {
                        return this.forceHexHash(color);
                    } else {
                        return '#666666';
                    }
                } else {
                    return '#666666';
                }
            } else {
                return '#666666';
            }
        },
        getSocialColor: function(field,type) {
            if (type == 'background') {
                if (this.signature.settings.socialIconColorType == 'branddefault') {
                    if (field.hasOwnProperty('brandColor')) {
                        return field.brandColor;
                    } else {
                        return '#000000';
                    }
                } else if (this.signature.settings.socialIconColorType == 'black') {
                    return '#000000';
                } else if (this.signature.settings.socialIconColorType == 'white') {
                    return '#FFFFFF';
                } else if (this.signature.settings.socialIconColorType == 'gray') {
                    return '#666666';
                } else if (this.signature.settings.socialIconColorType == 'trans') {
                    return 'trans';
                } else if (this.signature.settings.socialIconColorType == 'linkcolor') {
                    return this.signature.settings.linkColor;
                } else if (this.signature.settings.socialIconColorType == 'other') {
                    if (this.signature.settings.socialBackgroundColor) {
                        return this.forceHexHash(this.signature.settings.socialBackgroundColor);
                    } else {
                        return "#000000";
                    }
                } else {
                    return "#000000";
                }
            } else if (type == 'icon') {
                if (this.signature.settings.socialIconColorType == 'branddefault') {
                    if (this.signature.settings.socialIconShape == 'circleoutline') {
                        return field.brandColor;
                    } else {
                        return '#FFFFFF';
                    }
                } else if (this.signature.settings.socialIconColorType == 'black') {
                    if (this.signature.settings.socialIconShape == 'circleoutline') {
                        return '#000000';
                    } else {
                        return '#FFFFFF';
                    }
                } else if (this.signature.settings.socialIconColorType == 'white') {
                    if (this.signature.settings.socialIconShape == 'circleoutline') {
                        return '#FFFFFF';
                    } else {
                        return '#333333';
                    }
                } else if (this.signature.settings.socialIconColorType == 'gray') {
                    if (this.signature.settings.socialIconShape == 'circleoutline') {
                        return '#666666';
                    } else {
                        return '#FFFFFF';
                    }
                } else if (this.signature.settings.socialIconColorType == 'linkcolor') {
                    if (this.signature.settings.socialIconShape == 'circleoutline') {
                        return this.signature.settings.linkColor;
                    } else {
                        return '#FFFFFF';
                    }
                } else if (this.signature.settings.socialIconColorType == 'other' || this.signature.settings.socialIconColorType == 'trans') {
                    if (this.signature.settings.socialIconColor) {
                        return this.forceHexHash(this.signature.settings.socialIconColor);
                    } else {
                        return "#FFFFFF";
                    }
                } else {
                    return "#FFFFFF";
                }
            } else {
                return "#000000";
            }
        },
        removeSpaces: function(value) {
            return value.replace(/\s/g, '');
        },
        placeholderValue: function(field) {
            var fieldvalue = '';
            if (field && field.type === 'link' && field.editable === 'linkasvalue') {
                var fieldvalue = field.link;
                if (fieldvalue.lastIndexOf('https://', 0) !== -1) {
                    fieldvalue = fieldvalue.replace("https://", "");
                } else if (fieldvalue.lastIndexOf('http://', 0) !== -1) {
                    fieldvalue = fieldvalue.replace("http://", "");
                }
                fieldvalue = fieldvalue.replace(/\/$/, '');
                fieldvalue = fieldvalue.replace(/<[^>]*>?/gm, '');
            } else if (field && field.type === 'select') {
                var indexValue = field.value;
                var shouldDisplay = true;
                if (field.value === '' && (this.previewActive === false || field.required === true)) {
                    indexValue = 0;
                } else if (field.value === '' && field.required === false) {
                    shouldDisplay = false;
                }
                if (shouldDisplay && field.choices[indexValue]) {
                    if (field.choices[indexValue].value) {
                        fieldvalue = field.choices[indexValue].value.replace(/<[^>]*>?/gm, '');
                    } else if (this.previewActive === false) {
                        fieldvalue = 'Choices Field';
                    }
                }
            } else if (field && field.hasOwnProperty('value') && field.value !== '') {
                // if(field.hasOwnProperty('editable') && field.editable == 'linkasvalue') {
                //     fieldvalue = '';
                // } else {
                //     fieldvalue = field.value.replace(/<[^>]*>?/gm, '');
                // }
                if (field.type == 'textarea') {
                    fieldvalue = sanitizeHtml(field.value, {
                        allowedTags: [ 'b', 'strong', 'i', 'em', 'a', 'strike', 'del', 'div', 'br' ],
                        allowedAttributes: {
                            'a': [ 'href' ]
                        },
                    });
                } else {
                    fieldvalue = field.value.replace(/<[^>]*>?/gm, '');
                }
            } else {
                if (field.required === false) {
                    if (this.previewActive === false) {
                        if (field.placeholder !== '') {
                            fieldvalue = field.placeholder.replace(/<[^>]*>?/gm, '');
                        } else if (field.label !== '') {
                            fieldvalue = field.label.replace(/<[^>]*>?/gm, '');
                        } else {
                            fieldvalue = field.type.charAt(0).toUpperCase() + field.type.slice(1) + ' Field';
                        }
                    }
                } else {
                    if (this.previewActive === false) {
                        if (field.placeholder !== '') {
                            fieldvalue = field.placeholder.replace(/<[^>]*>?/gm, '');
                        } else if (field.label !== '') {
                            fieldvalue = field.label.replace(/<[^>]*>?/gm, '');
                        } else {
                            fieldvalue = field.type.charAt(0).toUpperCase() + field.type.slice(1) + ' Field';
                        }
                    } else {
                        fieldvalue = field.placeholder.replace(/<[^>]*>?/gm, '');
                    }
                }
            }
            if (field.type == 'textarea') {
                //var email_regex = /([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9._-]+)/gi;
                var colorStyle = '';
                if (field.slug == 'disclaimer') {
                    if (field.fontColor) {
                        colorStyle = 'color:' + this.forceHexHash(field.fontColor) + ';';
                    } else if (this.signature.settings.fontColor) {
                        colorStyle = 'color:' + this.forceHexHash(this.signature.settings.fontColor) + ';';
                    }
                } else {
                    if (this.signature.settings.linkColor) {
                        colorStyle = 'color:' + this.forceHexHash(this.signature.settings.linkColor) + ';';
                    }
                }
                //console.log(colorStyle);
                fieldvalue = linkifyHtml(fieldvalue, {defaultProtocol: 'https'});
                // if (this.previewActive === true) {
                //     fieldvalue = linkifyHtml(fieldvalue, { attributes: {
                //         style: 'text-decoration:underline;' + colorStyle,
                //     }});
                // } else {
                //     fieldvalue = linkifyHtml(fieldvalue, { tagName: 'span', attributes: {
                //         style: 'text-decoration:underline;' + colorStyle,
                //     }});
                // }
                if (this.previewActive === true) {
                    fieldvalue = fieldvalue.replace(/<a href="([^"]*)"/g, "<a href='$1' style='text-decoration:underline;" + colorStyle + "'");
                } else {
                    fieldvalue = fieldvalue.replace(/<a href="[^"]*"/g, "<span style='text-decoration:underline;" + colorStyle + "'").replace(/<\/a>/g, "</span>");
                }
            }
            if (field.textTransform && field.textTransform == 'uppercase') {
                fieldvalue = fieldvalue.toUpperCase();
            } else if (field.textTransform && field.textTransform == 'lowercase') {
                fieldvalue = fieldvalue.toLowerCase();
            }
            return fieldvalue;
        },
        linkPlaceholder: function(field) {
            if (field.type == 'link' && field.hasOwnProperty('editable') && field.editable == 'bothlinkvalue') {
                return 'https://';
            } else if (field.placeholder == '' || field.placeholder == null) {
                return 'https://';
            } else {
                return field.placeholder;
            }
        },
        forceHexHash: function(color) {
            if (color && (typeof color === 'string' || color instanceof String)) {
                if (color.indexOf('#') !== -1) {
                    return color;
                } else if (color.length == 6) {
                    return '#' + color;
                } else {
                    return '';
                }
            } else {
                return '';
            }
        },
        boxColumnPadding: function(line) {
            var styleTag = '';
            if (line.type == 'columns' || line.type == 'box') {
                var lineWidth = '';
                var lineStyle = '';
                if (line.type == 'columns') {
                    lineWidth = this.signatureWidth();
                } else if (line.type == 'box') {
                    lineWidth = this.lineWidth(line, false);
                }
                if (lineWidth !== '') {
                    if (String(lineWidth).indexOf('%') === -1) {
                        lineWidth = lineWidth + "px";
                    }
                    lineStyle = 'width:' + lineWidth + ';';
                }
                if (line.marginTop && line.marginTop > 0) {
                    lineStyle = lineStyle + 'padding-top:' + line.marginTop + 'px;';
                }
                if (line.marginRight && line.marginRight > 0) {
                    lineStyle = lineStyle + 'padding-right:' + line.marginRight + 'px;';
                }
                if (line.marginBottom && line.marginBottom > 0) {
                    lineStyle = lineStyle + 'padding-bottom:' + line.marginBottom + 'px;';
                }
                if (line.marginLeft && line.marginLeft > 0) {
                    lineStyle = lineStyle + 'padding-left:' + line.marginLeft + 'px;';
                }
                if (lineStyle !== '') {
                    styleTag = ' style="' + lineStyle + '"';
                }
            }
            return styleTag;
        },
        lineStyle: function(line) {
            var lineStyle = '';
            if (line && line.fontWeight == 'bold') {
                lineStyle = lineStyle + 'font-weight:bold;';
            } else if (this.signature.settings.fontWeight == 'bold') {
                lineStyle = lineStyle + 'font-weight:bold;';
            }
            if (line && line.fontStyle == 'italic') {
                lineStyle = lineStyle + 'font-style:italic;';
            } else if (this.signature.settings.fontStyle == 'italic') {
                lineStyle = lineStyle + 'font-style:italic;';
            }
            if (line && line.textDecoration == 'line-through') {
                lineStyle = lineStyle + 'text-decoration:line-through;';
            } else if (this.signature.settings.textDecoration == 'line-through') {
                lineStyle = lineStyle + 'text-decoration:line-through;';
            }
            if (line && line.fontColor) {
                lineStyle = lineStyle + 'color:' + this.forceHexHash(line.fontColor) + ';';
            } else if (this.signature.settings.fontColor) {
                lineStyle = lineStyle + 'color:' + this.forceHexHash(this.signature.settings.fontColor) + ';';
            }

            var fontSize = null;
            var lineHeight = null;
            if (line && line.fontSize) {
                fontSize = line.fontSize;
            } else if (this.signature.settings.fontSize) {
                fontSize = this.signature.settings.fontSize;
            }
            lineStyle = lineStyle + 'font-size:' + fontSize + 'px;';

            var hasImage = false;
            var imageHeight = 0;
            if (line.fields) {
                line.fields.forEach(function ( thefield, fieldindex ) {
                    if (thefield.type === 'image' && (thefield.url !== '' || (thefield.selfHosted && thefield.selfHostedUrl !== ''))) {
                        hasImage = true;
                        var tempHeight = null;
                        if (thefield.selfHosted && thefield.selfHostedHeight) {
                            tempHeight = thefield.selfHostedHeight;
                        } else {
                            tempHeight = Math.round((thefield.originalHeight * thefield.width) / thefield.originalWidth);
                        }
                        if (tempHeight > imageHeight) {
                            imageHeight = tempHeight;
                        }
                    } else if (thefield.type === 'icon') {
                        hasImage = true;
                        var tempHeight = null;
                        if (thefield.selfHosted && thefield.selfHostedHeight) {
                            tempHeight = thefield.selfHostedHeight;
                        } else if (thefield.iconOrigWidth > thefield.iconOrigHeight) {
                            tempHeight = Math.ceil((thefield.iconSize * thefield.iconOrigHeight) / thefield.iconOrigWidth);
                        } else {
                            tempHeight = Number(thefield.iconSize);
                        }
                        if (tempHeight > imageHeight) {
                            imageHeight = tempHeight;
                        }
                    } else if (thefield.type === 'social') {
                        hasImage = true;
                        var tempHeight = null;
                        if (thefield.selfHosted && thefield.selfHostedHeight) {
                            tempHeight = thefield.selfHostedHeight;
                        } else if (this.signature.settings.socialIconSize == 'small') {
                            tempHeight = 22;
                        } else if (this.signature.settings.socialIconSize == 'large') {
                            tempHeight = 42;
                        } else {
                            tempHeight = 32;
                        }
                        if (tempHeight > imageHeight) {
                            imageHeight = tempHeight;
                        }
                    } else if (thefield.type === 'button') {
                        hasImage = true;
                        var tempHeight = null;
                        if (thefield.selfHosted && thefield.selfHostedHeight) {
                            tempHeight = thefield.selfHostedHeight;
                        } else {
                            tempHeight = thefield.height;
                        }
                        if (tempHeight > imageHeight) {
                            imageHeight = tempHeight;
                        }
                    } else if (thefield.type === 'newbutton') {
                        hasImage = true;
                        var tempHeight = null;
                        if (thefield.selfHosted && thefield.selfHostedHeight) {
                            tempHeight = thefield.selfHostedHeight;
                        } else {
                            tempHeight = thefield.height;
                        }
                        if (tempHeight > imageHeight) {
                            imageHeight = tempHeight;
                        }
                    } else if (thefield.type === 'selectimage') {
                        var shouldDisplay = true;
                        var indexValue = thefield.value;
                        if (thefield.value === '') {
                            indexValue = 0;
                        } else if (thefield.value === '' && thefield.required === false) {
                            shouldDisplay = false;
                        }
                        if (shouldDisplay || this.previewActive) {
                            if (thefield.choices[indexValue] !== undefined) {
                                var imageField = thefield.choices[indexValue];
                                if (imageField.url !== '') {
                                    hasImage = true;
                                    //Someday this will need self hosted options as well!
                                    var tempHeight = Math.round((imageField.originalHeight * imageField.width) / imageField.originalWidth);
                                    if (tempHeight > imageHeight) {
                                        imageHeight = tempHeight;
                                    }
                                }
                            }
                        }
                    }
                }, this, hasImage, imageHeight);
            }
            if (hasImage && imageHeight > 0 && this.previewActive) {
                //var lineFieldCount = line.fields.length;
                //if (lineFieldCount == 1) {
                    lineStyle = lineStyle + 'height:' + imageHeight + 'px;';
                //} else {
                //    var totalLineHeight = imageHeight + Number(line.marginTop) + Number(line.marginBottom);
                //    lineStyle = lineStyle + 'mso-line-height-rule:exactly;line-height:' + totalLineHeight + 'px;';
                //}
            } else {
                if (line.type !== 'box' && line.type !== 'columns') {
                    var largestFontSize = this.findLargestFontSizeInLine(line);
                    if (largestFontSize && largestFontSize > fontSize) {
                        fontSize = largestFontSize;
                    }
                }
                if (fontSize && line.lineHeight == 'tight') {
                    lineHeight = Math.round(fontSize * 1.2);
                    lineStyle = lineStyle + 'mso-line-height-rule:exactly;line-height:' + lineHeight + 'px;';
                } else if (fontSize && line.lineHeight == 'comfortable') {
                    lineHeight = Math.round(fontSize * 1.5);
                    lineStyle = lineStyle + 'mso-line-height-rule:exactly;line-height:' + lineHeight + 'px;';
                } else if (fontSize && line.lineHeight == 'generous') {
                    lineHeight = Math.round(fontSize * 1.8);
                    lineStyle = lineStyle + 'mso-line-height-rule:exactly;line-height:' + lineHeight + 'px;';
                } else if (fontSize && this.signature.settings.lineHeight == 'tight') {
                    lineHeight = Math.round(fontSize * 1.2);
                    lineStyle = lineStyle + 'mso-line-height-rule:exactly;line-height:' + lineHeight + 'px;';
                } else if (fontSize && this.signature.settings.lineHeight == 'comfortable') {
                    lineHeight = Math.round(fontSize * 1.5);
                    lineStyle = lineStyle + 'mso-line-height-rule:exactly;line-height:' + lineHeight + 'px;';
                } else if (fontSize && this.signature.settings.lineHeight == 'generous') {
                    lineHeight = Math.round(fontSize * 1.8);
                    lineStyle = lineStyle + 'mso-line-height-rule:exactly;line-height:' + lineHeight + 'px;';
                }
            }
            if (line.type !== 'box' && line.type !== 'columns') {
                if (line.marginTop && line.marginTop > 0) {
                    lineStyle = lineStyle + 'padding-top:' + line.marginTop + 'px;';
                }
                if (line.marginRight && line.marginRight > 0) {
                    lineStyle = lineStyle + 'padding-right:' + line.marginRight + 'px;';
                }
                if (line.marginBottom && line.marginBottom > 0) {
                    lineStyle = lineStyle + 'padding-bottom:' + line.marginBottom + 'px;';
                }
                if (line.marginLeft && line.marginLeft > 0) {
                    lineStyle = lineStyle + 'padding-left:' + line.marginLeft + 'px;';
                }
                if (line.borderTop && line.borderTop > 0) {
                    var borderTopColor = '#333333';
                    if (line.borderTopColor) {
                        borderTopColor = this.forceHexHash(line.borderTopColor);
                    }
                    lineStyle = lineStyle + 'border-top:solid ' + line.borderTop + 'px ' + borderTopColor + ';';
                }
                if (line.borderRight && line.borderRight > 0) {
                    var borderRightColor = '#333333';
                    if (line.borderRightColor) {
                        borderRightColor = this.forceHexHash(line.borderRightColor);
                    }
                    lineStyle = lineStyle + 'border-right:solid ' + line.borderRight + 'px ' + borderRightColor + ';';
                }
                if (line.borderBottom && line.borderBottom > 0) {
                    var borderBottomColor = '#333333';
                    if (line.borderBottomColor) {
                        borderBottomColor = this.forceHexHash(line.borderBottomColor);
                    }
                    lineStyle = lineStyle + 'border-bottom:solid ' + line.borderBottom + 'px ' + borderBottomColor + ';';
                }
                if (line.borderLeft && line.borderLeft > 0) {
                    var borderLeftColor = '#333333';
                    if (line.borderLeftColor) {
                        borderLeftColor = this.forceHexHash(line.borderLeftColor);
                    }
                    lineStyle = lineStyle + 'border-left:solid ' + line.borderLeft + 'px ' + borderLeftColor + ';';
                }
            }
            if (line.fontFamily) {
                var fontFamily = this.fontFamily(line.fontFamily);
                if (fontFamily) {
                    lineStyle = lineStyle + "font-family:" + fontFamily + ";";
                }
            }
            if (line.textAlign) {
                if (line.textAlign !== 'left') {
                    lineStyle = lineStyle + 'text-align:' + line.textAlign + ';';
                }
            } else if (this.signature.settings.textAlign) {
                if (this.signature.settings.textAlign !== 'left') {
                    lineStyle = lineStyle + 'text-align:' + this.signature.settings.textAlign + ';';
                }
            }
            if (line.type == 'box') {
                if (line.backgroundColor) {
                    lineStyle = lineStyle + 'background-color:' + this.forceHexHash(line.backgroundColor) + ';';
                }
                if (!this.previewActive) {
                    if (line.marginTop && line.marginTop > 0) {
                        lineStyle = lineStyle + 'margin-top:' + line.marginTop + 'px;';
                    }
                    // if (line.paddingRight && line.paddingRight > 0) {
                    //     lineStyle = lineStyle + 'padding-right:' + line.paddingRight + 'px;';
                    // }
                    if (line.marginBottom && line.marginBottom > 0) {
                        lineStyle = lineStyle + 'margin-bottom:' + line.marginBottom + 'px;';
                    }
                    // if (line.paddingLeft && line.paddingLeft > 0) {
                    //     lineStyle = lineStyle + 'padding-left:' + line.paddingLeft + 'px;';
                    // }
                }
                if (line.width) {
                    lineStyle = lineStyle + 'width:' + line.width + 'px;';
                }
                // if (line.marginBottom && line.marginBottom > 0) {
                //     lineStyle = lineStyle + 'margin-bottom:' + line.marginBottom + 'px;';
                // }
                // if (line.marginTop && line.marginTop > 0) {
                //     lineStyle = lineStyle + 'margin-top:' + line.marginTop + 'px;';
                // }
            }
            // if (line.type == 'columns') {
            //     if (line.backgroundColor) {
            //         lineStyle = lineStyle + 'background-color:' + this.forceHexHash(line.backgroundColor) + ';';
            //     }
            //     if (line.paddingTop && line.paddingTop > 0) {
            //         lineStyle = lineStyle + 'padding-top:' + line.paddingTop + 'px;';
            //     }
            //     if (line.paddingRight && line.paddingRight > 0) {
            //         lineStyle = lineStyle + 'padding-right:' + line.paddingRight + 'px;';
            //     }
            //     if (line.paddingBottom && line.paddingBottom > 0) {
            //         lineStyle = lineStyle + 'padding-bottom:' + line.paddingBottom + 'px;';
            //     }
            //     if (line.paddingLeft && line.paddingLeft > 0) {
            //         lineStyle = lineStyle + 'padding-left:' + line.paddingLeft + 'px;';
            //     }
            //     if (line.width) {
            //         lineStyle = lineStyle + 'max-width:' + line.width + 'px;';
            //     }
            //     if (line.border && line.border > 0) {
            //         lineStyle = lineStyle + 'border-style:solid;border-width:' + line.border + 'px;';
            //         if (line.borderColor) {
            //             lineStyle = lineStyle + 'border-color:' + this.forceHexHash(line.borderColor) + ';';
            //         } else {
            //             lineStyle = lineStyle + 'border-color:#333333;';
            //         }
            //     }
            // }
            return lineStyle;
        },
        signatureAlign: function() {
            if (this.signature.settings.alignment) {
                if (this.signature.settings.alignment == 'center') {
                    return "align='center'";
                } else if (this.signature.settings.alignment == 'right') {
                    return "align='right'";
                } else {
                    return '';
                }
            } else {
                return '';
            }
        },
        signatureWidth: function() {
            if (this.signature.settings.width) {
                return this.signature.settings.width;
            } else {
                return '100%';
            }
        },
        lineWidth: function(line, excludePadding = true) {
            if (line.width) {
                var newWidth = line.width;
                if (excludePadding) {
                    if (line.paddingRight && line.paddingRight > 0) {
                        newWidth = newWidth - line.paddingRight;
                    }
                    if (line.paddingLeft && line.paddingLeft > 0) {
                        newWidth = newWidth - line.paddingLeft;
                    }
                    if (line.borderRight && line.borderRight > 0) {
                        newWidth = newWidth - line.borderRight;
                    }
                    if (line.borderLeft && line.borderLeft > 0) {
                        newWidth = newWidth - line.borderLeft;
                    }
                }
                return newWidth;
            } else {
                return "100%";
            }
        },
        boxStyle: function(box) {
            var boxStyle = '';
            if (!this.previewActive) {
                boxStyle = boxStyle + 'position:relative;';
            }
            if (box.paddingTop && box.paddingTop > 0) {
                boxStyle = boxStyle + 'padding-top:' + box.paddingTop + 'px;';
            }
            if (box.paddingRight && box.paddingRight > 0) {
                boxStyle = boxStyle + 'padding-right:' + box.paddingRight + 'px;';
            }
            if (box.paddingBottom && box.paddingBottom > 0) {
                boxStyle = boxStyle + 'padding-bottom:' + box.paddingBottom + 'px;';
            }
            if (box.paddingLeft && box.paddingLeft > 0) {
                boxStyle = boxStyle + 'padding-left:' + box.paddingLeft + 'px;';
            }
            if (box.fontFamily) {
                var fontFamily = this.fontFamily(box.fontFamily);
                if (fontFamily) {
                    boxStyle = boxStyle + "font-family:" + fontFamily + ";";
                }
            }
            var borderColor = '#333333';
            if (box.borderColor) {
                borderColor = this.forceHexHash(box.borderColor);
            }
            if (box.borderLocked && box.borderTop > 0) {
                boxStyle = boxStyle + 'border:solid ' + box.borderTop + 'px ' + borderColor + ';';
            } else {
                if (box.borderTop && box.borderTop > 0) {
                    boxStyle = boxStyle + 'border-top:solid ' + box.borderTop + 'px ' + borderColor + ';';
                }
                if (box.borderRight && box.borderRight > 0) {
                    boxStyle = boxStyle + 'border-right:solid ' + box.borderRight + 'px ' + borderColor + ';';
                }
                if (box.borderBottom && box.borderBottom > 0) {
                    boxStyle = boxStyle + 'border-bottom:solid ' + box.borderBottom + 'px ' + borderColor + ';';
                }
                if (box.borderLeft && box.borderLeft > 0) {
                    boxStyle = boxStyle + 'border-left:solid ' + box.borderLeft + 'px ' + borderColor + ';';
                }
            }
            return boxStyle;
        },
        columnsStyle(line) {
            var columnsStyle = '';
            if (line.border && line.border > 0) {
                var borderColor = '#333333';
                if (line.borderColor) {
                    borderColor = this.forceHexHash(line.borderColor);
                }
                columnsStyle = columnsStyle + 'border:solid ' + line.border + 'px ' + borderColor + ';';
            }
            if (!this.previewActive) {
                if (line.marginBottom && line.marginBottom > 0) {
                    columnsStyle = columnsStyle + 'margin-bottom:' + line.marginBottom + 'px;';
                }
                if (line.marginTop && line.marginTop > 0) {
                    columnsStyle = columnsStyle + 'margin-top:' + line.marginTop + 'px;';
                }
            }
            return columnsStyle;
        },
        singleColumnStyle: function(column, line) {
            var singleColumnStyle = '';
            if (!this.previewActive) {
                singleColumnStyle = singleColumnStyle + 'position:relative;';
            }
            var hasSomePadding = false;
            var hasTopPadding = false;
            var hasRightPadding = false;
            var hasBottomPadding = false;
            var hasLeftPadding = false;
            if (column.paddingTop && column.paddingTop > 0) {
                singleColumnStyle = singleColumnStyle + 'padding-top:' + column.paddingTop + 'px;';
                hasSomePadding = true;
                hasTopPadding = true;
            }
            if (column.paddingRight && column.paddingRight > 0) {
                singleColumnStyle = singleColumnStyle + 'padding-right:' + column.paddingRight + 'px;';
                hasSomePadding = true;
                hasRightPadding = true;
            }
            if (column.paddingBottom && column.paddingBottom > 0) {
                singleColumnStyle = singleColumnStyle + 'padding-bottom:' + column.paddingBottom + 'px;';
                hasSomePadding = true;
                hasBottomPadding = true;
            }
            if (column.paddingLeft && column.paddingLeft > 0) {
                singleColumnStyle = singleColumnStyle + 'padding-left:' + column.paddingLeft + 'px;';
                hasSomePadding = true;
                hasLeftPadding = true;
            }
            if (hasSomePadding === false) {
                singleColumnStyle = singleColumnStyle + 'padding:0px;';
            } else {
                if (hasTopPadding === false) {
                    singleColumnStyle = singleColumnStyle + 'padding-top:0px;';
                }
                if (hasRightPadding === false) {
                    singleColumnStyle = singleColumnStyle + 'padding-right:0px;';
                }
                if (hasBottomPadding === false) {
                    singleColumnStyle = singleColumnStyle + 'padding-bottom:0px;';
                }
                if (hasLeftPadding === false) {
                    singleColumnStyle = singleColumnStyle + 'padding-left:0px;';
                }
            }
            if (column.verticalAlign) {
                singleColumnStyle = singleColumnStyle + 'vertical-align:' + column.verticalAlign + ';';
            }
            if (column.width && column.width > 0) {
                var newWidth = column.width;
                if (column.paddingLeft && column.paddingLeft > 0) {
                    newWidth = newWidth - column.paddingLeft;
                }
                if (column.paddingRight && column.paddingRight > 0) {
                    newWidth = newWidth - column.paddingRight;
                }
                if (column.borderRight && column.borderRight > 0) {
                    newWidth = newWidth - column.borderRight;
                }
                if (column.borderLeft && column.borderLeft > 0) {
                    newWidth = newWidth - column.borderLeft;
                }
                singleColumnStyle = singleColumnStyle + 'width:' + newWidth + 'px;';
            }
            if (line.fontFamily) {
                var fontFamily = this.fontFamily(line.fontFamily);
                if (fontFamily) {
                    singleColumnStyle = singleColumnStyle + "font-family:" + fontFamily + ";";
                }
            }
            //TODO FOR COLUMNS!
            // if (columnName == 'column2' && line.borderMiddle && line.borderMiddle > 0) {
            //     var borderMiddleColor = '#333333';
            //     if (line.borderMiddleColor) {
            //         borderMiddleColor = this.forceHexHash(line.borderMiddleColor);
            //     }
            //     singleColumnStyle = singleColumnStyle + 'border-left:solid ' + line.borderMiddle + 'px ' + borderMiddleColor + ';';
            // }
            var borderColor = '#333333';
            if (column.borderColor) {
                borderColor = this.forceHexHash(column.borderColor);
            }
            if (column.borderLocked && column.borderTop > 0) {
                singleColumnStyle = singleColumnStyle + 'border:solid ' + column.borderTop + 'px ' + borderColor + ';';
            } else {
                if (column.borderTop && column.borderTop > 0) {
                    singleColumnStyle = singleColumnStyle + 'border-top:solid ' + column.borderTop + 'px ' + borderColor + ';';
                }
                if (column.borderRight && column.borderRight > 0) {
                    singleColumnStyle = singleColumnStyle + 'border-right:solid ' + column.borderRight + 'px ' + borderColor + ';';
                }
                if (column.borderBottom && column.borderBottom > 0) {
                    singleColumnStyle = singleColumnStyle + 'border-bottom:solid ' + column.borderBottom + 'px ' + borderColor + ';';
                }
                if (column.borderLeft && column.borderLeft > 0) {
                    singleColumnStyle = singleColumnStyle + 'border-left:solid ' + column.borderLeft + 'px ' + borderColor + ';';
                }
            }
            if (column.backgroundColor && column.backgroundColor !== '') {
                var backgroundColor = this.forceHexHash(column.backgroundColor);
                singleColumnStyle = singleColumnStyle + 'background-color:' + backgroundColor + ';';
            }
            return singleColumnStyle;
        },
        fontFamily(fontFamily) {
            if (fontFamily == 'sigdefault') {
                return this.fontFamily(this.signature.settings.fontFamily);
            } else if (fontFamily == 'Helvetica') {
                return 'Helvetica,Arial,sans-serif'; //Helvetica Neue
            } else if (fontFamily == 'Arial') {
                return "Arial, Helvetica, sans-serif"; //Helvetica Neue,
            } else if (fontFamily == 'Arial Black') {
                return "Arial Black, Arial Bold, Gadget, sans-serif;font-weight: 700";
            } else if (fontFamily == 'Arial Narrow') {
                return "Helvetica,Helvetica Neue,Arial,sans-serif";
            } else if (fontFamily == 'Arial Rounded') {
                return "Arial Rounded MT Bold, Helvetica Rounded, Arial, sans-serif";
            } else if (fontFamily == 'Century Gothic') {
                return "Century Gothic, CenturyGothic, AppleGothic, sans-serif";
            } else if (fontFamily == 'Verdana') {
                return "Verdana, Verdana Ref, sans-serif";
            } else if (fontFamily == 'Trebuchet') {
                return "Trebuchet MS, Verdana, Verdana Ref, sans-serif";
            } else if (fontFamily == 'Tahoma') {
                return "Tahoma, Verdana, Segoe, sans-serif";
            } else if (fontFamily == 'Gill Sans') {
                return "Gill Sans, Gill Sans MT, Calibri, sans-serif";
            } else if (fontFamily == 'Georgia') {
                return "Georgia,Times,Times New Roman,serif";
            } else if (fontFamily == 'Palatino') {
                return "Palatino, Palatino Linotype, Palatino LT STD, Book Antiqua, Georgia, serif";
            } else if (fontFamily == 'Lucida Bright') {
                return "Lucida Bright, Georgia, serif";
            } else if (fontFamily == 'Times New Roman') {
                return "Times, Times New Roman, serif";
            } else if (fontFamily == 'Courier New') {
                return "Courier New, Courier, Lucida Sans Typewriter, Lucida Typewriter, monospace";
            } else if (fontFamily == 'Lucida Sans Typewriter') {
                return "Lucida Sans Typewriter, Lucida Console, monaco, Bitstream Vera Sans Mono, monospace";
            } else if (fontFamily == 'Copperplate') {
                return "Copperplate, Copperplate Gothic Light, serif";
            } else if (fontFamily == 'Papyrus') {
                return "Papyrus, fantasy";
            } else if (fontFamily == 'Email Default (No Style)') {
                return null;
            }
        },
        columnWidth: function(column) {
            //TODO FOR COLUMNS!
            // if (two_columns[columnName].width) {
            //     var padding_and_borders = 0;
            //     if (two_columns[columnName].paddingRight && two_columns[columnName].paddingRight > 0) {
            //         padding_and_borders = padding_and_borders + two_columns[columnName].paddingRight;
            //     }
            //     if (two_columns[columnName].paddingLeft && two_columns[columnName].paddingLeft > 0) {
            //         padding_and_borders = padding_and_borders + two_columns[columnName].paddingLeft;
            //     }
            //     if (columnName == 'column2' && two_columns[columnName].borderMiddle && two_columns[columnName].borderMiddle > 0) {
            //         padding_and_borders = padding_and_borders + two_columns[columnName].borderMiddle;
            //     }
            //     if (padding_and_borders > 0) {
            //         return two_columns[columnName].width - padding_and_borders;
            //     } else {
            //         return two_columns[columnName].width;
            //     }
            // } else {
            //    return '50%';
            //}
            if (column.width) {
                var newWidth = column.width;
                if (column.paddingRight && column.paddingRight > 0) {
                    newWidth = newWidth - column.paddingRight;
                }
                if (column.paddingLeft && column.paddingLeft > 0) {
                    newWidth = newWidth - column.paddingLeft;
                }
                if (column.borderRight && column.borderRight > 0) {
                    newWidth = newWidth - column.borderRight;
                }
                if (column.borderLeft && column.borderLeft > 0) {
                    newWidth = newWidth - column.borderLeft;
                }
                return newWidth;
            } else {
                return '50%';
            }

        },
        fieldStyle: function (field) {
            var fieldStyle = '';
            if (field && field.fontWeight == 'bold') {
                fieldStyle = fieldStyle + 'font-weight:bold;';
            }
            if (field && field.fontStyle == 'italic') {
                fieldStyle = fieldStyle + 'font-style:italic;';
            }
            if (field && field.textDecoration == 'line-through') {
                fieldStyle = fieldStyle + 'text-decoration:line-through;';
            }
            if (field && field.fontColor) {
                fieldStyle = fieldStyle + 'color:' + this.forceHexHash(field.fontColor) + ';';
            }
            if (field && field.fontSize) {
                fieldStyle = fieldStyle + 'font-size:' + field.fontSize + 'px;';
            }
            if (field && field.letterSpacing) {
                if (field.letterSpacing == 'tight') {
                    fieldStyle = fieldStyle + 'letter-spacing:-1px;';
                } else if (field.letterSpacing == 'generous') {
                    fieldStyle = fieldStyle + 'letter-spacing:2px;';
                } else if (field.letterSpacing == 'reallygenerous') {
                    fieldStyle = fieldStyle + 'letter-spacing:5px;';
                }
            }
            // if (field.lineHeight) {
            //     if (field.lineHeight == 'tight') {
            //         fieldStyle = fieldStyle + 'mso-line-height-rule:exactly;line-height:1.2em;';
            //     }
            //     if (field.lineHeight == 'comfortable') {
            //         fieldStyle = fieldStyle + 'mso-line-height-rule:exactly;line-height:1.5em;';
            //     }
            //     if (field.lineHeight == 'generous') {
            //         fieldStyle = fieldStyle + 'mso-line-height-rule:exactly;line-height:1.8em;';
            //     }
            // }
            //fieldStyle = fieldStyle + "font-family:" + this.fontFamily('sigdefault') + ";";
            return fieldStyle;
        },
        selectImageChoice: function(choice, index, field) {
            if (field.value === index) {
                if (field.required) {
                    //do nothing
                } else {
                    field.value = '';
                }
            } else {
                field.value = index;
            }
        },
        getImageChoiceUrl: function(choice) {
            if (this.signature.settings.selfHostedImages && choice.selfHosted && choice.selfHostedUrl) {
                return choice.selfHostedUrl;
            } else if (choice.url !== '') {
                return this.getImageUrl() + '/' + choice.url;
            } else {
                return this.getImageUrl() + '/placeholders/placeholder-image.gif';
            }
        },
        checkSingleFieldValid: function(field) {
            if (this.triedToSubmit) {
                this.checkIfValidToCopy();
            } else {
                if (field && field.type == 'image' && field.hasOwnProperty('required') && field.required === true) {
                    if ((field.link == '' || field.link == null) && (field.editable == 'link' || field.editable == 'bothimagelink')) {
                        field.valid = false;
                    } else {
                        field.valid = true;
                    }
                } else if (field && (field.type == 'link' || field.type == 'social' || field.type == 'button') && field.hasOwnProperty('required') && field.required === true) {
                    if ((field.link == '' || field.link == null) && field.editable == 'link') {
                        field.valid = false;
                    } else if ((field.link == '' || field.link == null || field.value === '' || field.value === null) && (field.editable == 'bothlinkvalue' || field.editable == 'linkasvalue')) {
                        field.valid = false;
                    } else if ((field.value === '' || field.value === null) && field.editable == 'value') {
                        field.valid = false;
                    } else {
                        field.valid = true;
                    }
                } else if (field && field.hasOwnProperty('editable') && field.editable !== "no" && field.editable !== "displaytoggle" && field.hasOwnProperty('required') && field.required === true && (field.value === '' || field.value === null)) {
                    field.valid = false;
                } else {
                    field.valid = true;
                }
            }
        },
        checkFieldValid: function(field) {
            if (field && field.type == 'image') {
                if (field.hasOwnProperty('editable') && field.editable == "image" && field.hasOwnProperty('required') && field.required === true) {
                    if ((field.hasOwnProperty('placeholderImage') && field.placeholderImage === true) || field.url == '') {
                        return false;
                    } else {
                        return true;
                    }
                } else if (field.hasOwnProperty('editable') && field.editable == "bothimagelink" && field.hasOwnProperty('required') && field.required === true) {
                    if ((field.hasOwnProperty('placeholderImage') && field.placeholderImage === true) || field.url == '' || field.url == null || field.link == '' || field.link == null) {
                        return false;
                    } else {
                        return true;
                    }
                } else if (field.hasOwnProperty('editable') && field.editable == "link" && field.hasOwnProperty('link') && (field.link == '' || field.link == null) && field.required === true) {
                    if (field.link == '' || field.link == null) {
                        return false;
                    } else {
                        return true;
                    }
                } else {
                    return true;
                }
            } else if (field && (field.type == 'link' || field.type == 'social' || field.type == 'button' )) {
                if (field && field.hasOwnProperty('editable') && field.hasOwnProperty('required') && field.required === true) {
                    if (field.hasOwnProperty('link') && (field.link == '' || field.link == null) && (field.editable == 'link' || field.editable == 'linkasvalue')) {
                        return false;
                    } else if (field.hasOwnProperty('link') && field.hasOwnProperty('value') && ((field.link == '' || field.link == null) || (field.value === '' || field.value === null)) && field.editable == 'bothlinkvalue') {
                        return false;
                    } else if (field.hasOwnProperty('value') && (field.value === '' || field.value === null) && (field.editable == 'value' || field.editable == 'linkasvalue')) {
                        return false;
                    } else {
                        return true;
                    }
                } else {
                    return true;
                }
            } else if (field && field.type == 'email') {
                if (field && field.hasOwnProperty('editable') && field.editable !== "no" && field.editable !== "displaytoggle" && field.hasOwnProperty('required') && field.required === true && field.hasOwnProperty('value') && field.value === '') {
                    return false;
                } else if (field && field.hasOwnProperty('editable') && field.editable !== "no" && field.editable !== "displaytoggle" && field.hasOwnProperty('required') && field.required === false && field.hasOwnProperty('value') && field.value === '') {
                    return true;
                } else if (field && field.hasOwnProperty('editable') && field.editable !== "no" && field.editable !== "displaytoggle" && field.hasOwnProperty('value') && this.validateEmail(field.value) === false) {
                    return false;
                } else {
                    return true;
                }
            } else {
                if (field && field.hasOwnProperty('editable') && field.editable !== "no" && field.editable !== "displaytoggle" && field.hasOwnProperty('required') && field.required === true && field.hasOwnProperty('value') && field.value === '') {
                    return false;
                } else {
                    return true;
                }
            }
        },
        copyToClipboard: function() {
            var self = this;
            if (self.view == 'designer') {
                if (typeof gtag != "undefined") {
                    gtag('event', 'copy', {
                        'event_category': 'Designer',
                    });
                }
            } else {
                if (typeof gtag != "undefined") {
                    gtag('event', 'copy', {
                        'event_category': 'Generator',
                    });
                }
            }
            if (self.previewActive && self.single_signature === false) {
                self.triedToSubmit = true;
                self.checkIfValidToCopy();
            }
            self.saveEmployeeSignature(true);
            //console.log(self.purchased);
            
            //console.log(self.$refs);
            //self.copyCodeMode = true;                
            //self.$nextTick(function () {
                if (self.validToCopy) {
                    if (typeof self.saveTemplate === "function" && self.user_id && self.organization_id && self.signatureid) {
                        self.saveTemplate(false);
                    }
                    if (self.canCopySignature()) {
                        self.copyText(self.createRawSignature());
                    } else {
                        self.selectSignature();
                    }
                    //this.copyText(this.$refs.signature.innerHTML);
                }
                
                //this.copyCodeMode = false;
            //});
        },
        saveEmployeeSignature: function(savequietly = false) {
            var self = this;
            if (self.purchased && self.signatureid && self.validToCopy && self.single_signature === false) {
                if (self.disable_signature_tracks === false) {
                    var tempStatsValue = null;
                    if (self.hasEditableRequiredEmail) {
                        tempStatsValue = self.checkForEditableRequiredEmail('fieldvalue');
                    } else {
                        tempStatsValue = self.statsEmail;
                    }
                    var object_to_send = {signatureid: self.signatureid, signature: this.signature, email: tempStatsValue, employeesignatureid: self.employeesignatureid, employeeid: self.employeeid};
                    axios.post('/employee-signature', null, { data: object_to_send } )
                    .then(function (response) {
                        if (response.data.status == 'success') {
                            self.employeesignature_old = false;
                            if (savequietly === false) {
                                var message = 'Signature saved!'
                                if (self.mode === 'admin') {
                                    message = 'Employee signature saved!';
                                }
                                Vue.notify({
                                    group: 'bottomleftmessages',
                                    title: message,
                                    type: 'success',
                                });
                            }
                        } else if (response.data.status == 'error') {
                            Vue.notify({
                                group: 'bottomleftmessages',
                                title: response.data.message,
                                type: 'error',
                            });
                        } else {
                            Vue.notify({
                                group: 'bottomleftmessages',
                                title: 'Sorry, there was a problem saving the signature.',
                                type: 'error',
                            });
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
                }
            }
        },
        checkStatsEmail: function() {
            if (this.statsEmail == null || this.statsEmail == '') {
                this.statsEmailValid = false;
            } else {
                this.statsEmailValid = true;
            }
            if (this.triedToSubmit) {
                this.checkIfValidToCopy();
            } else {
                //do nothing...
            }
        },
        checkIfValidToCopy: function() {
            var self = this;
            var newValid = true;
            self.signature.lines.forEach(function ( line, lineindex ) {
                if (line.type == 'box') {
                    line.lines.forEach(function ( boxline ) {
                        boxline.fields.forEach(function ( thefield, fieldindex ) {
                            if (self.checkFieldValid(thefield) === false) {
                                thefield.valid = false;
                                newValid = false;
                            } else {
                                thefield.valid = true;
                            }
                        });
                    }, line, self, newValid);
                } else if (line.type == 'columns') {
                    line.columns.forEach(function ( column ) {
                        column.lines.forEach(function ( columnsline ) {
                            if (columnsline.type == 'box') {
                                columnsline.lines.forEach(function ( boxline ) {
                                    boxline.fields.forEach(function ( thefield, fieldindex ) {
                                        if (self.checkFieldValid(thefield) === false) {
                                            thefield.valid = false;
                                            newValid = false;
                                        } else {
                                            thefield.valid = true;
                                        }
                                    }, line, self, newValid);
                                }, line, self, newValid);
                            } else {
                                columnsline.fields.forEach(function ( thefield, fieldindex ) {
                                    if (self.checkFieldValid(thefield) === false) {
                                        thefield.valid = false;
                                        newValid = false;
                                    } else {
                                        thefield.valid = true;
                                    }
                                }, line, self, newValid);
                            }
                        }, line, self, newValid);
                    }, line, self, newValid);
                } else {
                    line.fields.forEach(function ( thefield, fieldindex ) {
                        if (self.checkFieldValid(thefield) === false) {
                            thefield.valid = false;
                            newValid = false;
                        } else {
                            thefield.valid = true;
                        }
                    }, self, newValid);
                }
            }, self, newValid);
            // console.log("yoyo");
            // console.log(self.statsEmail);
            // console.log(self.validateEmail(self.statsEmail));
            if ((self.statsEmail == null || self.statsEmail == '') && self.hasEditableRequiredEmail === false) {
                newValid = false;
                self.statsEmailValid = false;
            } else if (self.validateEmail(self.statsEmail) === false && self.hasEditableRequiredEmail === false) {
                newValid = false;
                self.statsEmailValid = false;
            } else {
                self.statsEmailValid = true;
            }
            if (newValid === false) {
                self.$refs.sidebarscroll.scrollTop = 0;
            }
            self.validToCopy = newValid;
        },
        validateEmail: function(email) {
            var re = /\S+@\S+\.\S+/;
            return re.test(email);
        },
        canCopySignature() {
            if (this.isIE10orBelow()) {
                return false;
            } else if (this.isIE11()) {
                return false;
            } else if (this.isiOS()) {
                return false;
            //} else if(this.isAndroid()) {
            //    return false;
            } else {
                return true;
            }
        },
        isIE10orBelow: function() {
            // IE 10 or older, return version number
            //return ('IE ' + parseInt(ua.substring(
            //  msie + 5, ua.indexOf('.', msie)), 10));
            var ua = navigator.userAgent;
            var msie = ua.indexOf('MSIE ');
            if (msie > 0) {
                return true;
            } else {
                return false;
            }
        },
        isIE11: function() {
            // IE 11, return version number
            //var rv = ua.indexOf('rv:');
            //return ('IE ' + parseInt(ua.substring(
            //  rv + 3, ua.indexOf('.', rv)), 10));
            var ua = navigator.userAgent;
            var trident = ua.indexOf('Trident/');
            if (trident > 0) {
                return true;
            } else {
                return false;
            }
        },
        isiOS: function() {
            var ua = navigator.userAgent;
            return /iPad|iPhone|iPod/.test(ua) && !window.MSStream;
        },
        isAndroid: function() {
            var ua = navigator.userAgent;
            return ua.indexOf("android") > -1; //&& ua.indexOf("mobile");
        },
        copyText: function(textToCopy) {

            //http://jsfiddle.net/jdhenckel/km7prgv4/3

            // function listener(e) {
            //     e.clipboardData.setData("text/html", textToCopy);
            //     e.clipboardData.setData("text/plain", textToCopy);
            //     e.preventDefault();
            // }

            // document.addEventListener("copy", listener);
            // document.execCommand("copy");
            // document.removeEventListener("copy", listener);

            //https://github.com/lgarron/clipboard-polyfill
            var dt = new clipboard.DT();
            dt.setData("text/plain", textToCopy);
            dt.setData("text/html", textToCopy);
            clipboard.write(dt);

            this.signatureDistributionMode = 'copy';
            this.signatureCopiedModal = true;
           
        },
        hideSignatureCopiedModal() {
            this.signatureCopiedModal = false;
            this.signatureDistributionMode = null;
        },
        selectSignature() {
            //https://stackoverflow.com/questions/17675056/set-selection-by-range-in-javascript/30038591
            //var $newSelection = $('.someElements');

            //Possible solution, switch contentEditable quick before and after copy?
            //https://stackoverflow.com/questions/34045777/copy-to-clipboard-using-javascript-in-ios

            var selection = window.getSelection();
            var range = document.createRange();
            // range.setStartBefore(this.$refs.signature);
            // range.setEndAfter(this.$refs.signature);
            range.selectNodeContents(this.$refs.signature);
            selection.removeAllRanges();
            selection.addRange(range);
        }
    }
}
